export default {
  attributes: {
    invoicing_firm: {
      invoicing_firm_validated: 'Razón Social verificada',
      select_condition: 'Seleccione una condición',
      no_permission_to_create: 'No tienes Permisos para crear',
      invoice_number: 'Último núm. de factura',
      credit_note_number: 'Último núm. de notas de crédito',
      fiscal_info: 'Información Fiscal',
      general_info: 'Información General',
      last_credit_note_number: 'Últimos números de notas de crédito',
      last_credit_note_numbers: 'Último números de notas de crédito',
      last_invoice_number: 'Últimos números de facturas',
      last_invoice_numbers: 'Último números de facturas',
      use_account_data: 'Usar datos de su cuenta',
      invoicing_invoicing_configuration_id: 'Configuración',
      argentina: {
        invoicing_invoicing_configuration_id: 'Configuración',
        invoicing_firm_validated: 'Razón Social verificada',
        verify_webservice_connection: 'Verificar conexión con webservice',
        upload_afip_certificate: ' Subir el certificado otorgado por afip',
        no_electronic_invoice: 'Sin información para mostrar',
        certificate_expiration_date: ' Expiración del certificado',
        afip_doc: 'Documentación Servicio de AFIP',
        conf_afip_step_1:
          'Primer paso: Descargar el pedido para solicitar el certificado en la AFIP. Este pedido lo generó el sistema en función de los datos de la razón social.',
        conf_afip_step_2:
          'Segundo paso: Subir el certificado generado por AFIP. Dado que con este certificado se pedirá acceso a AFIP para generar las facturas electrónicas.',
        conf_afip_step_3: 'Tercer paso: Verificar que el certificado funciona correctamente con el webservice de AFIP.',
        upload_certificate: 'Subir certificado',
        request_afip: 'Pedido AFIP',
        check_webservice: 'Check webservice',
        last_invoice_numbers: 'Últimos números de facturas',
        last_credit_note_numbers: 'Últimos números de notas de crédito',
        afip_service: 'Servicio de AFIP',
        electronic_validated: 'Razón Social electrónica verificada',
        electronic_unvalidated: 'Razón Social electrónica no verificada',
        banelco_code: 'Nro de empresa asignado por Banelco para PagoMisCuentas',
        current_credit_note_number_voucher_a: 'Argentina (A)',
        current_credit_note_number_voucher_b: 'Argentina (B)',
        current_credit_note_number_voucher_c: 'Argentina (C)',
        current_invoice_number_argentina_a: 'Argentina (A)',
        current_invoice_number_argentina_b: 'Argentina (B)',
        current_invoice_number_argentina_c: 'Argentina (C)',
        self_employed_taxpayer: 'Responsable Monotributo',
        taxpayer_identification_number: 'CUIT/CUIL'
      },
      colombia: {
        invoicing_invoicing_configuration_id: 'Configuración',
        invoice_provider: 'Proveedor',
        resolution_date: 'Fecha de resolución',
        resolution_number: 'Resolución',
        current_selector: 'Utilizar ésta numeración como actual?',
        service_password: 'Token Password',
        service_url: 'Endpoint (FactoryHKA)',
        service_user: 'Token Empresa',
        taxpayer_identification_number: 'CC/CE/NIT',
        use_pdfs_from_service: 'Enviar PDF de FactoryHKA',
        vat_condition: 'Régimen',
        electronic_provider: 'Proveedor Electrónico (datos de su cuenta)',
        use_account_data: 'Usar datos de su cuenta',
        sale_point_town: 'Municipio',
        electronic_validated: 'Razón Social electrónica verificada',
        electronic_unvalidated: 'Razón Social electrónica no verificada',
        no_retentions_for_periodic: 'Las facturas periódicas se generaran SIN retenciones.',
        create_new_numeration: 'Crear nueva numeración',
        in_use: 'En uso',
        expire_at: 'Fecha de expiración',
        credit_notes: 'Notas de Crédito',
        old_pools: 'Numeraciones previas',
        electronic_verify: 'Verificar cuenta electrónica',
        warning_tab_invoice: 'No podrá facturar sin números autorizados',
        warning_tab_credit_note: 'No podrá anular facturas sin números',
        colombia_factory_hka_configuration: 'Configuración Factory HKA',
        colombia_factory_hka: 'Factory HKA',
        hka_documentation: 'Documentación de Factory HKA',
        colombia_dgo_configuration: 'Configuración DGO',
        colombia_siigo_configuration: 'Configuración Siigo',
        colombia_siigo_authorize_payment_configuration: 'Configuración de pago',
        colombia_siigo: 'Siigo',
        siigo: {
          errors: {
            cash_receipt_already_exists:
              'Esta factura ya tiene un recibo de caja en Siigo. No es posible crear un nuevo recibo de caja.',
            customer_doesnt_exist: 'El cliente no existe en Siigo.',
            inactive_customer: 'El cliente se encuentra inactivo en Siigo.',
            inactive_payment:
              'Error en la Configuración. Revise la configuración de siigo, el metodo de pago seleccionado esta inactivo en siigo',
            invalid_amount_value: 'Error en la Configuración. El valor del monto de recibo de caja es invalido',
            invalid_cash_receipt_date:
              'Revise la configuración en Siigo, la fecha del comprobante debe ser obligatoria',
            invalid_cash_receipt_document_type:
              'Revise la configuración en Siigo, el tipo de comprobante de recibo de caja debe ser obligatorio',
            invalid_cash_receipt_type: 'Error en la Configuración. El tipo de recibo de caja debe ser obligatorio',
            invalid_document_id: 'El tipo de comprobante no puede ser usado, revise su configuración en Siigo.',
            invalid_number_invoice: 'Error en el numero de factura. Revise la factura e intente nuevamente',
            invalid_payment_id: 'Revise la configuración en Siigo, el ID del pago debe ser obligatorio',
            invalid_payment_value: 'Revise la configuración en Siigo, el monto del pago debe ser obligatorio',
            number_already_exists: 'Revise el tipo de comprobante en Siigo, la numeración debe ser automática.',
            non_editable_document_id: 'El documento no es editable, revise su configuración en Siigo.',
            payment_method_required: 'Método de pago requerido',
            read_only_product: 'El producto está en modo lectura, revise su configuración en Siigo.',
            unhandled_error: 'Error desconocido.'
          },
          siigo_authorize_payment: 'Autorizar pago',
          siigo_authorize_payment_enabled_info:
            '<bold>Autorizar pago (Activado):</bold> la factura se creará "pendiente" con la forma de pago genérica, y por cada pago de la factura, se registrarán en Siigo. Es importante vincular las formas de pago en la razón social.',
          siigo_authorize_payment_disabled_info:
            '<bold>Autorizar pago (Desactivado):</bold> la factura se crea "pagada", con la forma de pago configurada en el cliente. Los pagos no serán registrados en Siigo.',
          siigo_cash_receipt_document_type: 'Tipo de comprobante de recibo de caja',
          siigo_cash_receipt_document_type_info:
            '<bold>Tipo de comprobante de recibo de caja:</bold> seleccioná el tipo de comprobante que se usará para generar el Recibo de caja en Siigo al registrar un pago.',
          siigo_credit_note_document_type_info:
            '<bold>Comprobante de nota de crédito:</bold> seleccioná el comprobante de Nota crédito electrónica que se usará para anular o ajustar facturas. Debe estar activo y configurado como documento electrónico.',
          siigo_dgo_product: 'Producto/Servicio (DGO)',
          siigo_dgo_product_info:
            '<bold>Producto/Servicio (DGO):</bold> seleccioná el producto o servicio del catálogo de Siigo que vas a usar para facturar los cargos de DIRECTV GO (packs/servicio DGO).',
          siigo_dgo_identification: 'Identificación (DGO)',
          siigo_dgo_identification_info:
            '<bold>Identificación (DGO):</bold> ingresá la identificación del tercero para poder facturar los cargos de DIRECTV GO como un ingreso para terceros.',
          siigo_link_payment_ways: 'Vincular formas de pago Siigo',
          siigo_link_payment_ways_title: 'Siigo - Vincular formas de pago',
          siigo_payment_type: 'Forma de pago',
          siigo_payment_type_info:
            '<bold>Forma de pago:</bold> seleccioná la forma de pago que se usará para crear la factura “pendiente” en Siigo.',
          siigo_save_settings: 'Guardar configuración',
          siigo_select_payment_way: 'Seleccione una forma de pago',
          siigo_invoice_document_type_info:
            '<bold>Tipo de comprobante de factura:</bold> seleccioná el comprobante de Factura electrónica de venta con el que se numerarán y emitirán las facturas. Debe estar activo (“En uso”) y configurado como documento electrónico para su envío a la DIAN.',
          siigo_product_info:
            '<bold>Producto/Servicio:</bold> seleccioná el producto o servicio del catálogo de Siigo que la integración usará para generar la factura. Debe existir y estar correctamente configurado (cuentas, impuestos y retenciones).',
          activate_net_amount_text: 'Para revisar esta configuración puede ir a',
          use_net_amount: 'Usar montos de facturación como valores netos',
          configurate_siigo: 'Configurar Siigo',
          service_password: 'Access Key',
          service_user: 'Usuario API',
          sigo_documentation: 'Documentación de Siigo',
          siigo_alert_message:
            'Para facturar con Siigo, debe usar los montos de facturación como valores netos. Para revisar esta configuración puede ir a',
          siigo_no_retentions: 'Las facturas se generaran SIN retenciones.',
          siigo_configuration_successful_updated: 'Se configuró Siigo exitosamente',
          siigo_resend_transaction: 'Reenviar transacción',
          siigo_resent_transaction_error: 'Error al reenviar la transacción',
          siigo_resent_transaction_successful: 'Transacción reenviada con éxito',
          cash_receipt_name: 'Número de Comprobante'
        }
      },
      peru: {
        invoicing_invoicing_configuration_id: 'Configuración',
        nubefact_alert_message:
          'Para facturar con Nubefact, debe usar los montos de facturación como valores netos. Para revisar esta configuración por favor contacte con soporte',
        electronic_unvalidated: 'Razón Social electrónica no verificada',
        electronic_validated: 'Razón Social electrónica verificada',
        final_consumer_invoice_serial_peru: 'Prefijo Boleta',
        first_final_consumer_invoice_number: 'Primer número de boleta',
        first_final_consumer_invoice_number_hint:
          'Coloque el número de la última boleta de la serie, si es una serie nueva, coloque 1',
        first_invoice_number: 'Primer númbero de factura',
        first_invoice_number_hint:
          'Coloque el número de la última factura de la serie, si es una serie nueva, coloque 1',
        general_regime: 'Regimen General',
        invoice_serial_peru: 'Prefijo Factura',
        nubefact: 'NubeFacT',
        service_password: 'Token',
        service_url: 'Ruta',
        taxpayer_identification_number: 'RUC',
        use_account_data: 'Usar datos de su cuenta',
        generate_numeration: 'Configurar numeración',
        generate_testing_invoice: 'Generar facturas de prueba',
        verify_invoicing_firm: 'Verificar razón social',
        generic_general_regime: 'Regimen General',
        mype_regime: 'Regimen MYPE',
        new_unique_simplified_regime: 'Nuevo Regimen Unico Simplificado (NRUS)',
        peru_next_invoice_number: 'Factura de ventas',
        peru_next_invoice_credit_note_number: 'Nota de Crédito de factura de ventas',
        peru_next_final_consumer_invoice_number: 'Boleta de venta',
        peru_next_final_consumer_invoice_credit_note_number: 'Nota de crédito de boleta de venta',
        peru_nube_fact: 'NubeFacT',
        not_generated_message: 'Si usted ya se encuentra en modo producción con NubeFacT, no presione este boton',
        generating_message: 'Las Facturas se estan generando',
        generated_message: 'las facturas ya fueron generadas contactese con NubeFacT',
        nubefact_form_message:
          'La numeración empezará desde 1 para comenzar a utilizar NubeFacT, en el caso de que ya tenga NubeFacT en producción contáctese con soporte para poder configurar la numeración'
      },
      ecuador: {
        accounting_description: 'Obligado a llevar contabilidad',
        billing_regime: 'Régimen de Facturación',
        certificate_updated: 'El Certificado y Contraseña fueron actualizados',
        conf_fiscal_step_1: 'Obtener certificado',
        conf_fiscal_step_2: 'Subir Certificado',
        contifico: {
          configurate_contifico: 'Configurar',
          contifico_authorize_payment: 'Autorizar pago',
          contifico_configuration_successful_updated: 'Se configuró Contifico exitosamente',
          contifico_ice_product_id: 'Producto y Servicio (ICE)',
          contifico_iva_product_id: 'Producto y Servicio (IVA)',
          contifico_link_payment_ways: 'Vincular formas de pago Contifico',
          contifico_link_payment_ways_title: 'Contifico - Vincular formas de pago',
          validate_invoice_provider_contifico: 'Validar Cuenta de Contifico'
        },
        ecuador_contifico: 'Contifico',
        ecuador_contifico_configuration: 'Configuración Contifico',
        ecuador_sri: 'SRI',
        electronic_provider: 'Proveedor Electrónico',
        electronic_unvalidated: 'Razón Social electrónica no verificada',
        electronic_validated: 'Razón Social electrónica verificada',
        fiscal_doc: 'Ver documentación',
        fiscal_info: 'Información Fiscal',
        fiscal_step_1: 'Obtener certificado (.p12). Deberá gestionarlo con alguna de las entidades autorizadas.',
        fiscal_step_2:
          'Subir el certificado (.p12). Dado que con este certificado se autorizarán las facturas electronicas con el SRI.',
        fiscal_title: 'Dar de alta el certificado',
        general_regime: 'Régimen General',
        invoice_provider: 'Proveedor',
        invoicing_invoicing_configuration_id: 'Configuración',
        ecuador_first_credit_note: 'Primer número de nota de crédito',
        ecuador_first_invoice: 'Primer número de factura',
        principal_activity: 'Nombre Comercial',
        pyme_description: 'Régimen Microempresas',
        retention_agent_number: 'Agente de Retención Resolución No.',
        rimpe_description: 'Régimen RIMPE',
        sale_point: 'Punto de Emisión',
        sale_point_address: 'Dirección del Establecimiento',
        sale_point_code: 'Código de Establecimiento',
        sell_invoice: 'Factura de Venta',
        sell_invoice_hint: 'Solo el número, sin prefijos (xxx-xxx-000000000)',
        service_password: 'API Key',
        service_user: 'API Token',
        taxpayer: 'Contribuyente',
        taxpayer_identification_number: 'RUC',
        upload_certificate: 'Subit .p12'
      },
      mexico: {
        invoicing_invoicing_configuration_id: 'Configuración',
        general_regime: 'Régimen General de Ley Personas Morales',
        taxpayer_identification_number: 'RFC',
        vat_condition: 'Régimen',
        update_production_credentials: 'Completar los datos con la información recibida de Facturación Moderna',
        generate_testing_dataset: 'Generación del set de datos de pruebas para enviarlo a Facturación Moderna.',
        verify_credentials: 'Verificación de conexión con Facturación Moderna',
        modern_step_1: 'Generar y descargar el set de datos',
        modern_step_2: 'Habilitar las credenciales de producción',
        modern_step_3: 'Verificar credenciales',
        generate_dataset: 'Generar Set de datos',
        update_dataset: 'Actualizar datos',
        fiscal_doc: 'Ver guia',
        use_account_data: 'Usar datos de su cuenta',
        modern_invoicing_title: 'Configurar Facturación Moderna',
        service_user: 'Usuario',
        service_password: 'Contraseña',
        service_url: 'Endpoint',
        fm_wsdl: 'Wsdl',
        fm_certificate_number: 'Num. Certificado',
        fm_logo: 'Logo ID',
        use_pdfs_from_service: 'Usar Pdf de Facturación Moderna',
        modern_info: 'Facturación Moderna (datos de su cuenta)'
      }
    },
    acs_server: {
      name: 'Nombre',
      host: 'Host',
      port: 'Puerto',
      user: 'Usuario',
      password: 'Contraseña',
      brand: 'Marca',
      authorization_token: 'Token de autorización',
      web_protocol: 'Protocolo web',
      http_port: 'Puerto HTTP',
      https_port: 'Puerto HTTPS',
      http_acs_port: 'Puerto ACS HTTP',
      https_acs_port: 'Puerto ACS HTTPS',
      websocket_port: 'Puerto websocket'
    },
    address: {
      addressable_id: 'Asociado a',
      client_netmask: 'Máscara de red del cliente',
      dns_one: 'Primer DNS',
      dns_two: 'Segundo DNS',
      free_ip_prefix: '[Libre]',
      gateway: 'Puerta de enlace',
      host: 'Host',
      ip: 'Dirección IP',
      nat_pool_ip_prefix: '[Balanceo NAT]',
      netmask: 'Máscara de red',
      server_configuration_id: 'Servidor',
      use_in_nat_pool: 'Usar en balanceo de NAT'
    },
    agent: {
      linked_to_wisprobox: 'Vinculado a WisproBox',
      create_new_agent: 'Crear nuevo Box',
      acs_access_url: 'Acceso',
      select_acs: 'Seleccione ACS',
      select_agents: 'Seleccione Agentes',
      token: {
        hint: 'Se requiere el Token para vincular WisproBox'
      }
    },
    audit: {
      auditable_id: 'ID del modelo',
      auditable_type: 'Modelo',
      changes: 'Cambios realizados',
      created_at_eq_date: 'Fecha de creación',
      event_eq_any: 'Acción',
      event_eq_any_create: 'Crear',
      event_eq_any_delete: 'Eliminar',
      event_eq_any_update: 'Actualizar',
      item_id: 'ID',
      item_id_eq: 'ID',
      item_types: {
        inventory_movement: 'Movimiento de Inventario',
        invoicing: {
          contract: 'Configuración de facturación',
          client: 'Configuración de facturación',
          plan: 'Plan'
        },
        dgo: {
          pack: 'Pack DGO',
          subscription: 'Suscripción DGO',
          service: 'Servicio DGO',
          transaction: 'Transacción DGO'
        },
        forwarded_port: 'Redirección de Puerto',
        help_desk: {
          issue: 'Ticket'
        },
        bmu: 'BMU'
      },
      not_found: 'Registro no encontrado',
      select_advanced: 'Seleccione una opción',
      whodunnit_eq: 'Usuario Responsable'
    },
    avoid_balancing_host: {
      provider: 'Proveedor'
    },
    bmu_version: {
      version_changes: 'Cambios realizados en la versión'
    },
    client: {
      at_least_invoicing_client_delinquent: 'Al menos un contrato moroso',
      client_id: 'ID Cliente', //Se usa para buscador "hablar con Pablo o Charly"
      export_only_filtered: 'Exportar solo los filtrados',
      export_all_invalid_mobiles_filtered: 'Exportar números de celulares inválidos',
      without_payment_gateways_filter: 'Sin pasarelas de pago',
      with_payment_gateways: 'Pasarelas de pago',
      invoices_filter_title: 'Clientes (Facturación)',
      clients_filter_title: 'Clientes',
      devices_using_internet_alert_mobile_app: 'Dispositivos usando App mobile Alerta Internet:',
      physical: 'Persona física',
      other: 'Otro',
      juridic: 'Persona jurídica',
      paid_unidentified: 'Pago - No identificado',
      invoice: 'Factura',
      unpaid: 'Impaga',
      paid: 'Pagada',
      draft: 'Borrador',
      void: 'Anulada',
      additional_one: 'Información adicional',
      additional_two: 'Información adicional 2',
      available_credit_on_account: 'Credito disponible en cuenta',
      balance_ca: 'Balance C/C',
      barcode_siro: 'Código de barras',
      concept: {
        mexico: 'Uso de CFDI'
      },
      contracts_state_eq_any_title: 'Estado de Contrato',
      contracts_state_eq_any_alerted: 'Alertado',
      contracts_state_eq_any_degraded: 'Degradado',
      contracts_state_eq_any_disabled: 'Deshabilitado',
      contracts_state_eq_any_enabled: 'Habiltado',
      delinquent_contracts_filter_eq_title: 'Estado de Facturación',
      delinquent_contracts_filter_delinquent: 'Con contratos morosos',
      delinquent_contracts_filter_up_to_date: 'Sin contratos morosos',
      create_new_client: 'Crear nuevo Cliente',
      custom_id: 'ID Cliente personalizable',
      device_token: 'Token de dispositivo',
      devices_filter_both: 'Ambos',
      devices_filter_has_devices: 'Con dispositivo',
      devices_filter_no_devices: 'Sin dispositivo',
      digital_barcode: 'Código de barras del cliente',
      // generate_the_invoice_the_days: 'Generar la factura los días',
      generate_the_invoice_the_days: 'Ciclo de facturación comienza el dia',
      has_contracts_filter_both: 'Ambos',
      associated_contracts: 'Contrato asociado:',
      has_contracts_filter_with: 'Con contrato',
      has_contracts_filter_without: 'Sin contrato',
      invoicing_client_additional_one_null_both: 'Ambos',
      invoicing_client_additional_one_null_no_present: 'No Presente',
      invoicing_client_additional_one_null_present: 'Presente',
      invoicing_client_additional_one_null_title: 'Información adicional',
      invoicing_client_authorize_invoice_after_paid_eq_both: 'Ambos',
      invoicing_client_authorize_invoice_after_paid_eq_false: 'Deshabilitado',
      invoicing_client_authorize_invoice_after_paid_eq_title: 'Informar después de pagar',
      invoicing_client_authorize_invoice_after_paid_eq_true: 'Habilitado',
      invoicing_client_automatic_state_eq_both: 'Ambos',
      invoicing_client_automatic_state_eq_false: 'Deshabilitado',
      invoicing_client_automatic_state_eq_title: 'Estado Automático',
      invoicing_client_automatic_state_eq_true: 'Habilitado',
      invoicing_client_invoicing_enabled_eq_both: 'Ambos',
      invoicing_client_invoicing_enabled_eq_false: 'Deshabilitado',
      invoicing_client_invoicing_enabled_eq_title: 'Facturación',
      invoicing_client_invoicing_enabled_eq_true: 'Habilitado',
      last_number_informed_in_siro: 'Último número informado en Siro',
      link_payments_code: 'Código LinkPagos',
      link_payments_siro: 'Código de Pago Electrónico',
      max_download: 'Máx. Bajada',
      max_upload: 'Máx. Subida',
      name: 'Nombre y apellido',
      name_lastname: 'Nombre y Apellido',
      paranoia_active: 'Activos',
      paranoia_both: 'Ambos',
      paranoia_deleted: 'Borrados',
      paranoia_filter: 'Status del cliente',
      payment_gateways: {
        pichincha: {
          form: {
            account_debit_kind: 'Tipo de cuenta',
            client_gateway_id: 'Cédula del titular de la cuenta',
            account_name: 'Nombre del titular de la cuenta',
            account_number: 'Número de cuenta',
            mi_vecino_hint:
              'Mi vecino: El cliente debe abonar su factura en los puntos de ventas del Banco Pichincha, con su Cédula/RUC.',
            automatic_debit_hint:
              'Débito automático: El cliente autoriza que su factura se debite automáticamente de la cuenta bancaria.',
            current_account: 'Cuenta corriente',
            saving_account: 'Caja de ahorro',
            title: 'Datos de la cuenta para débito automático',
            unique_pichincha_code: 'Código Único Pichincha'
          }
        }
      },
      pending_invoices_filter_both: 'Ambos',
      pending_invoices_filter_title: 'Facturas pendientes',
      pending_invoices_filter_without: 'Sin facturas pendientes',
      phone_mobile: 'Teléfono celular',
      phone_mobile_verified_eq_both: 'Ambos',
      phone_mobile_verified_eq_dissable: 'No verificado',
      phone_mobile_verified_eq_enable: 'Verificado',
      placeholder_basic_search:
        'Puedes buscar por: Nombre, E-mail de contacto, Teléfono fijo, Documento o Cédula de identidad, Teléfono celular, Dirección, ID Cliente personalizable, Dirección IP',
      reference: 'Referencia',
      select_client: 'Debe seleccionar al menos un cliente',
      start_invoicing_day_gteq: 'Día de facturación (desde)',
      start_invoicing_day_lteq: 'Día de facturación (hasta)',
      status_type: 'Estado (Tipo)',
      with_credit_both: 'Ambos',
      with_credit_title: 'Credito',
      with_credit_filter_with: 'Con crédito',
      with_credit_without: 'Sin crédito',
      with_invoicing_errors_both: 'Ambos',
      with_invoicing_errors_filter_with: 'Con errores de facturación',
      with_invoicing_errors_without: 'Sin errores',
      with_pending_invoices_with: 'Con facturas pendientes',
      deactivated: 'Borrado',
      details: 'Observaciones',
      email: 'E-mail de contacto',
      external_client_number: 'Nº de cliente',
      id: 'ID',
      invoicing_frecuency: {
        ['1']: 'Mensual',
        ['2']: 'Bimestral',
        ['3']: 'Trimestral',
        ['4']: 'Cuatrimestral',
        ['6']: 'Semestral',
        ['12']: 'Anual'
      },
      national_identification_number: 'Documento o Cédula de identidad',
      password_confirmation: 'Confirmación',
      phone: 'Teléfono fijo',
      phone_mobile_verified: 'Teléfono verificado',
      state: 'Provincia/Estado/Región',
      taxpayer_identification_number: 'Número de identificación tributaria',
      zoneables_zone_ids: 'Zona',
      massive_update_errors: 'Errores de actualización masiva',
      kind_person_physical: 'Persona física',
      kind_person_juridic: 'Persona jurídica',
      kind_person_other: 'Otro'
    },
    cloud_license: {
      button_enable_internal_use: 'Habilitar uso interno',
      button_disable_internal_use: 'Deshabilitar uso interno',
      acs_license: {
        cloud_license_id: 'ID de la licencia Cloud',
        installation_price: 'Precio de instalación',
        installation_price_hint: 'Se cobra por única vez al cliente',
        price: 'Precio de ACS',
        summary: 'Resumen'
      },
      approve: 'Aprobado',
      authorization_expired: 'Autorización expirada',
      authorized: 'Pago autorizado',
      cardholder_name: 'Titular',
      changes_history: 'Cambios recientes',
      current_billing_cycle: 'Ciclo actual',
      current_number_of_clients: 'Cantidad de clientes actuales',
      decline: 'Rechazado',
      discount_expiration_date: 'Fecha de expiración',
      discount_used: 'Descuento finalizado',
      expiration_date: 'Fecha de expiración',
      extended_until: 'Extensión de suscripción',
      fail: 'Falló',
      failed: 'Falló',
      gateway_rejected: 'Pago rechazado',
      has_trial: 'Días free',
      hola_suite: {
        annual: 'Anual',
        annual_price: 'Precio anual',
        channels: 'items (Chat GPT, ChatWeb, Instagram, Messenger, Pabx, Telegram, Web)',
        chat_gpt_enabled: 'Chat Gpt',
        chat_gpt_price: 'Precio (Chat Gpt)',
        chat_web_enabled: 'Chat web',
        chat_web_price: 'Precio (Chat Web)',
        cloud_service: 'Cloud',
        cloud_service_price: 'Precio (Cloud)',
        extra_accesses: 'Accesos extras',
        extra_accesses_price: 'Precio de accesos extras',
        extra_accesses_price_hint: 'El precio es por cada acceso',
        gupshup: 'Gupshup',
        hello_suite: 'Hola Suite',
        hint_price: 'Licencia de Hola + Hospedaje básico + Whatsapp + 3 Accesos',
        instagram_enabled: 'Instagram',
        instagram_price: 'Precio (Instagram)',
        installation: 'Instalación',
        installation_price: 'Precio de instalación',
        installation_price_hint: 'Se cobra por única vez al cliente',
        kind_whatsapp_api: 'API de whatsapp',
        license_hola: 'Licencia de Hola',
        messenger_enabled: 'Messenger',
        messenger_price: 'Precio (Messenger)',
        monthly: 'Mensual',
        monthly_price: 'Precio mensual',
        next_due_date: 'Próximo vencimiento',
        pabx_enabled: 'Pabx',
        pabx_price: 'Precio (Pabx)',
        partner: 'Partner',
        price: 'Precio Hola Suite',
        price_with_discount: 'Precio con descuento',
        serial_number: 'Número de serie',
        summary: 'Resumen',
        telegram_enabled: 'Telegram',
        telegram_price: 'Precio (Telegram)',
        web_enabled: 'Web',
        web_price: 'Precio (Web)',
        whatsapp_enabled: 'Whatsapp',
        whatsapp_price: 'Precio (Whatsapp)',
        whatsapp_quantity: 'Cantidad de cuentas de Whatsapp',
        token: 'TOKEN',
        url: 'URL',
        url_hint: 'URL válida: https://ejemplo.com'
      },
      input_installation_price: {
        hint: 'Se cobra por única vez al cliente',
        name: 'Precio de instalación'
      },
      installation_price: 'Precio de instalación',
      invoices: {
        status: {
          draft: 'Borrador',
          open: 'Impaga',
          paid: 'Pagada',
          uncollectible: 'Incobrable',
          void: 'Anulada'
        }
      },
      last_4: 'Últimos dígitos',
      license_type: 'Suscripción',
      licenses: {
        basic: 'BASIC',
        pro: 'PRO',
        yarly_pro: 'PRO (Anual)',
        yearly_basic: 'BASIC (Anual)'
      },
      next_billing_date: 'Próximo vencimiento',
      no_more_discount: 'No hay más descuentos',
      paid_until: 'Pagado hasta',
      pass: 'Exitoso',
      past_due: 'Vencido',
      payment_method_token: 'Método de pago',
      price_with_discount: 'Precio con descuento',
      pro: 'Pro',
      processor_declined: 'El procesador ha rechazado el pago',
      remaining_days_free: 'Días free restantes',
      remaining_months_discount: 'Meses restantes con descuento',
      review: 'Revisado',
      settled: 'Pagado',
      settlement_declined: 'Pago denegado',
      settlement_pending: 'Pago pendiente',
      settling: 'Pagando',
      statuses: {
        active: 'Activa',
        blocked: 'Bloqueado',
        canceled: 'Cancelada',
        failed: 'Falló',
        incomplete_expired: 'Expirado',
        new_user: 'Nuevo',
        past_due: 'Vencida',
        trialing: 'Prueba',
        unpaid: 'No pagada'
      },
      submitted_for_settlement: 'Pago asentado',
      succeeded: 'Exitoso',
      total_clients: 'Cantidad de contratos',
      transaction_details: 'Detalles de la transacción',
      vendor_status: 'Estado del proveedor',
      voided: 'Pago anulado'
    },
    concept: {
      mexico: {
        commodity: 'G01 - Adquisición de mercancías',
        returns_discounts_bonuses: 'G02 - Devoluciones, descuentos o bonificaciones',
        general_expenses: 'G03 - Gastos en general',
        buildings: 'I01 - Construcciones',
        furniture_and_office_equipment_for_investments: 'I02 - Mobiliario y equipo de oficina por inversiones',
        transportation_equipment: 'I03 - Equipo de transporte',
        computer_equipment_and_accessories: 'I04 - Equipo de computo y accesorios',
        craps_dies_molds_matrixes_and_tooling: 'I05 - Dados, troqueles, moldes, matrices y herramental',
        telephone_communications: 'I06 - Comunicaciones telefónicas',
        satellite_communications: 'I07 - Comunicaciones satelitales',
        other_machinery_and_equipment: 'I08 - Otra maquinaria y equipo',
        medical_fee_dental_and_hospital_expenses: 'D01 - Honorarios médicos, dentales y gastos hospitalarios',
        medical_expenses_due_to_incapacity: 'D02 - Gastos médicos por incapacidad o discapacidad',
        funeral_expenses: 'D03 - Gastos funerales',
        donations: 'D04 - Donativos',
        interest_paid_for_mortgage_loans:
          'D05 - Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación)',
        voluntary_contributions_to_SAR: 'D06 - Aportaciones voluntarias al SAR',
        medical_expense_insurance: 'D07 - Primas por seguros de gastos médicos',
        school_transportation_expenses: 'D08 - Gastos de transportación escolar obligatoria',
        deposits_in_savings_accounts_based_on_pension_plans:
          'D09 - Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones',
        payments_for_educational_services: 'D10 - Pagos por servicios educativos (colegiaturas)',
        no_tax_effects: 'S01 - Sin efectos fiscales',
        payments: 'CP01 - Pagos',
        paysheet: 'CN01 - Nómina',
        to_define_cfdi: 'P01 - Por definir'
      }
    },
    contract: {
      acs_server: 'Servidor ACS',
      acs_server_id: 'Servidor ACS',
      address_ip: 'Dirección IP',
      address_ip_cont: 'Dirección IP',
      authorize_ont_in_service: 'Autorizar onu en el serivicio de olt',
      automatic_catv_control_enabled: 'Control CATV automático',
      automatic_catv_control_enabled_eq: 'Control CATV',
      automatic_catv_control_enabled_eq_both: 'Ambos',
      automatic_catv_control_enabled_eq_disabled: 'Desahabilitado',
      automatic_catv_control_enabled_eq_enabled: 'Habilitado',
      board: 'Board',
      cable_modem_enabled: 'Cable modem habilitado',
      cable_modem_enabled_eq: 'Cable Modem',
      cable_modem_enabled_eq_both: 'Ambos',
      cable_modem_enabled_eq_disabled: 'Deshabilitado',
      cable_modem_enabled_eq_enabled: 'Habilitado',
      cable_modem_file: 'Cable modem archivo DOCSIS binario personalizado',
      cable_modem_gateway: 'Cable modem puerta de enlace',
      cable_modem_ip: 'Cable modem ip',
      cable_modem_mac_address: 'Cable modem mac address',
      cable_modem_mac_address_cont: 'Dirección MAC Cable modem',
      ceil_dfl_percent: 'Porcentaje Ceil DFL',
      ceil_dfl_percent_eq: 'Porcentaje Ceil DFL',
      client: 'Cliente',
      client_city_eq: 'Ciudad',
      client_collector_id_eq: 'Recaudador',
      client_custom_id_eq: 'ID Cliente personalizable',
      client_invoicing_client_automatic_state_eq: 'Estado automático',
      client_invoicing_client_automatic_state_eq_both: 'Ambos',
      client_invoicing_client_automatic_state_eq_disabled: 'Deshabilitado',
      client_invoicing_client_automatic_state_eq_enabled: 'Habilitado',
      client_invoicing_client_invoicing_enabled_eq: 'Facturación',
      client_invoicing_client_invoicing_enabled_eq_both: 'Ambos',
      client_invoicing_client_invoicing_enabled_eq_disabled: 'Deshabilitado',
      client_invoicing_client_invoicing_enabled_eq_enabled: 'Habilitado',
      client_invoicing_client_invoicing_firm_id_eq: 'Razón Social',
      client_invoicing_client_taxpayer_identification_number_cont: 'Número de identificación tributaria',
      client_name_unaccent_cont: 'Nombre y apellido',
      client_national_identification_number_cont: 'Documento ó Cédula de identidad',
      client_neighborhood_id_eq: 'Barrio',
      client_seller_id_eq: 'Vendedor',
      client_sequential_id_eq: 'ID Cliente',
      client_state_eq: 'Provincia/Estado/Región',
      client_zoneables_zone_id_eq: 'Zona',
      contract_discounts: 'Descuentos',
      contract_with_error: 'Contrato con error',
      contracts_with_errors: 'Contratos con errores',
      coverage: 'Cobertura',
      coverage_id: 'Cobertura',
      coverage_id_eq: 'Cobertura',
      coverage_node_id_eq: 'Nodo',
      cpe_port: 'Puerto CPE',
      cpe_protocol: 'Protocolo CPE',
      created_at: 'Creado el',
      created_at_gteq: 'Creado en (Inicio)',
      created_at_lteq: 'Creado en (Fin)',
      custom_netmask: 'Máscara de red',
      date_start: 'Fecha de inicio',
      deleted_at: 'Eliminado el',
      delinquent_date_by_system: 'Moroso automáticamente el',
      delinquent_status: 'Estado de facturación',
      destination: 'Destino',
      details: 'Observaciones',
      details_unaccent_cont: 'Observaciones',
      dhcp_enable: 'DHCP Habilitado',
      dhcp_enabled: 'Habilitar DHCP',
      dhcp_enabled_eq: 'DHCP',
      dhcp_enabled_eq_both: 'Ambos',
      dhcp_enabled_eq_disabled: 'Desahabilitado',
      dhcp_enabled_eq_enabled: 'Habilitado',
      dhcp_mac_address: 'Dirección MAC Relay',
      dhcp_mac_address_cont: 'Dirección MAC DHCP Relay',
      dhcp_mac_defined_by_service: 'DHCP Relay',
      dhcp_server: 'Servidor DHCP',
      discounts_to_apply_filter: 'Descuentos',
      discounts_to_apply_filter_both: 'Ambos',
      discounts_to_apply_filter_with: 'Con descuentos',
      discounts_to_apply_filter_without: 'Sin descuentos',
      dns_one: 'Primer DNS',
      dns_two: 'Segundo DNS',
      due_from: 'Vencimiento desde (Fechas)',
      due_to: 'Vencimiento hasta (Fechas)',
      extra_vlans: 'Extra Vlans',
      extra_vlans_cont: 'Extra Vlans',
      extra_vlans_hint: "Escribe las Vlans sin espacios y separadas por comas, ejem: '101,102,103'",
      file_delimiter: 'Separador',
      file_encoding: 'Encoding',
      fill_field: 'Debe completar al menos un campo en el formulario',
      format_serial_to_hex: 'Formatear serial number a formato hex',
      forwarded_port: {
        address: 'Dirección',
        interface: 'Interfaz',
        private_port: 'Puerto privado',
        public_port: 'Puerto público',
        tcp: 'tcp',
        udp: 'udp'
      },
      forwarded_ports_tooltip: 'Redirección de puertos',
      frame: 'Frame',
      gateway: 'Puerta de enlace',
      general_info: 'Información General',
      gps_point_attributes: {
        additional_data: 'Dato adicional',
        city: 'Ciudad',
        country: 'País',
        latitude: 'Latitud',
        longitude: 'Longitud',
        number: 'Número',
        state: 'Provincia',
        street: 'Calle'
      },
      gps_point_number_or_gps_point_street_unaccent_cont: 'Dirección',
      has_acs: 'ACS',
      id: 'ID',
      id_or_sequential_id_eq: 'Contrato (ID)',
      interface_gpon: 'Interfaz GPON',
      interface_gpon_eq: 'Interfaz (Ej. 0/0/1 or g0/1)',
      inventory_article_ids: 'Articulos',
      inventory_articles: 'Articulos',
      invoicing_contract_delinquent: ' Moroso',
      invoicing_contract_disabled_date_by_system: 'Deshabilitado por el sistema el',
      invoicing_contract_disabled_date_by_system_gteq: 'Deshabilitado por el sistema el (Desde)',
      invoicing_contract_disabled_date_by_system_lteq: 'Deshabilitado por el sistema el (Hasta)',
      invoicing_contract_profile_id_eq: 'Perfil',
      invoicing_contract_social_stratum_eq: 'Estrato social',
      invoicing_contract_start_invoicing_date_eq: 'Fecha inicio facturación',
      invoicing_contract_up_to_date: 'Al día (sin mora)',
      invoicing_info: 'Información de Facturación',
      ip: 'IP',
      items_completed: 'items facturados',
      items_completed_infinity: 'items facturados (se facturará indefinidamente)',
      items_remaining: 'items por facturar',
      mac_address: 'Dirección MAC',
      mac_address_cont: 'Dirección MAC',
      mac_address_for_dhcp: 'MAC address para DHCP',
      massive_update: {
        add_period: 'Agregar periodo',
        ceil_dfl_percent: 'Porcentaje Ceil DFL',
        cpe_port: 'Puerto CPE',
        cpe_protocol: 'Protocolo CPE',
        current_period: 'Periodo actual',
        delete_period: 'Eliminar periodo',
        details: 'Observaciones',
        invoicing_contract_attributes: {
          invoicing_profile_id: 'Perfil de facturación',
          price: 'Precio'
        },
        massive_update: 'Actualización masiva',
        mikrotik_interface_id: 'Interfaz Mikrotik',
        plan_id: 'Plan',
        ppp_profile_id: 'Perfil PPP',
        server_configuration_id: 'Servidor',
        state: 'Estado',
        subtract_period: 'Restar periodo'
      },
      massive_update_preview_prefix: 'Se Actualizaran ',
      massive_update_preview_subfix: ' los datos a actualizar son:',
      mikrotik_address_network: 'Red',
      mikrotik_interface_id: 'Interfaz Mikrotik',
      mikrotik_priority_queue_hint:
        'Para habilitar las configuraciones Mikrotik, debe seleccionar primero un Servidor Mikrotik en la pestaña de Básico',
      mikrotik_traffic_control: 'Control de ancho de banda Mikrotik',
      mu: {
        frecuency: ' Frecuencia de facturación',
        olt_mode: 'OLT Mode',
        pppoe_server: ' Nombre del servidor PPPoE',
        wireless_node: 'NODO Wireless'
      },
      name: 'Nombre',
      nap_id: 'NAP',
      nap_id_eq: 'NAP',
      navigation_vlan: 'Vlan',
      navigation_vlan_eq: 'Vlan',
      netmask: 'Máscara de red',
      no_client_selected_text: 'Elige uno en el Input de Clientes',
      no_client_selected_title: 'No hay Cliente Seleccionado',
      no_consumption_summary_data: 'No hay datos de consumo',
      no_options_interface: 'No se encontraron interfaces Lan',
      no_permission_to_action:
        '<0>No hay ONU asociada. Requiere autorización:</0> No tiene permisos para realizar acciones',
      olt_enabled_eq: 'OLT habilitado',
      olt_enabled_eq_both: 'Ambos',
      olt_enabled_eq_disabled: 'Desahabilitado',
      olt_enabled_eq_enabled: 'Habilitado',
      olt_id_eq_any: 'OLTs',
      olt_traffic_control_enabled: 'Control de ancho de banda OLT',
      olt_traffic_control_enabled_eq: 'Control de ancho de banda OLT',
      olt_traffic_control_enabled_eq_both: 'Ambos',
      olt_traffic_control_enabled_eq_disabled: 'Desahabilitado',
      olt_traffic_control_enabled_eq_enabled: 'Habilitado',
      olt_wan_provisioning: 'Aprovisionar WAN',
      olt_wan_provisioning_eq: 'Aprovisionamiento WAN',
      olt_wan_provisioning_eq_both: 'Ambos',
      olt_wan_provisioning_eq_disabled: 'Deshabilitado',
      olt_wan_provisioning_eq_enabled: 'Habilitado',
      online_eq: 'Estado ONU',
      online_eq_both: 'Ambos',
      online_eq_disabled: 'Offline',
      online_eq_enabled: 'Online',
      online_state: `Contrato: (Conectado)`,
      online_state_both: 'Ambos',
      online_state_offline: 'Desconectado',
      online_state_online: 'Conectado',
      ont_action: 'Acción ONU',
      ont_action_unlink: 'Desvincular',
      ont_action_unauthorize: 'Desautorizar',
      ont_action_reconfig: 'Reconfigurar',
      ont_action_migration: 'Migrar',
      ont_custom_tr069_profile: 'Perfil TR069',
      ont_custom_tr069_profile_hint: 'Escribe el profile-name del Perfil TR069 a utilizar.',
      ont_desync: 'ONU Desincronizada',
      ont_id: 'ONU',
      ont_id_not_null: 'Con ONUs vinculadas',
      ont_id_not_null_both: 'Ambos',
      ont_id_not_null_false: 'Sin ONUs',
      ont_id_not_null_true: 'Con ONUs',
      ont_last_down_cause: 'Última causa de desconexión ONU',
      ont_mode: 'Modo ONU',
      ont_number: 'ID ONU',
      ont_number_eq: 'ID ONU',
      ont_offline: 'ONU Offline',
      ont_only_link: 'Modo link',
      ont_routing_mode: 'Modo ONU',
      ont_serial_number: 'Número de Serie ONU',
      ont_serial_number_eq: 'Número de Serie ONU',
      ont_authorization_state_eq: 'Estado de autorización ONU',
      ont_signal_eq: 'Señal ONU',
      ont_signal_eq_all: 'Todas',
      ont_signal_eq_critical: 'Crítica',
      ont_signal_eq_warning: 'Alarmante',
      paranoia_active: 'Activos',
      paranoia_both: 'Ambos',
      paranoia_deleted: 'Borrados',
      paranoia_filter: 'Status del contrato',
      parent_queue: 'Cola Principal',
      plan_bmu: 'Plan',
      plan_id: 'Plan',
      plan_id_eq: 'Plan',
      port_prios: 'Puertos prioritarios',
      ppp_profile: 'Perfil PPP',
      ppp_profile_form_collection: 'Perfil PPP',
      ppp_profile_id: 'Perfil Ppp',
      ppp_profile_id_eq: 'Perfil PPP',
      ppp_profile_searcher_collection: 'Perfil PPP',
      pppoe_enabled: 'Habilitar PPPoE',
      pppoe_enabled_eq: 'PPPoE',
      pppoe_enabled_eq_both: 'Ambos',
      pppoe_enabled_eq_disabled: 'Desahabilitado',
      pppoe_enabled_eq_enabled: 'Habilitado',
      pppoe_password: 'PPPoE Password',
      pppoe_username: 'PPPoE Username',
      pppoe_username_cont: 'Usuario PPPoE',
      prio_helpers: 'Netfilter helpers que obtendrán prioridad',
      prio_protos: 'Protocolos completos que obtendrán prioridad',
      priority_download_queue: 'Prioridad de cola de descarga',
      priority_upload_queue: 'Prioridad de cola de subida',
      provisioning_mode: 'Modo de aprovisionamiento',
      public_address: 'Dirección FULL-NAT',
      public_address_id: 'Dirección FULL-NAT',
      public_address_id_null: 'FULL-NAT',
      public_address_id_null_both: 'Ambos',
      public_address_id_null_not_present: 'No Presente',
      public_address_id_null_present: 'Presente',
      public_address_ip_cont: 'FULL-NAT (IP)',
      routing_mode: 'Modo Router',
      routing_mode_eq: 'Modo',
      routing_mode_eq_both: 'Ambos',
      routing_mode_eq_disabled: 'Bridge',
      routing_mode_eq_enabled: 'Router',
      seal_code_matches: 'Nombre de precinto',
      searcher_tabs: {
        client: 'Cliente',
        contract: 'Contrato',
        invoicing: 'Facturación'
      },
      select_contract: 'Debe Seleccionar al menos un contrato',
      sequential_id: 'ID Contrato',
      sequential_id_eq: 'ID Contrato',
      server_configuration: 'Servidor',
      server_configuration_id: 'Servidor',
      server_configuration_id_eq_any: 'Servidores',
      server_traffic_control_enabled: 'Control de ancho de banda Servidor',
      server_traffic_control_enabled_eq: 'Control de ancho de banda Servidor',
      server_traffic_control_enabled_eq_both: 'Ambos',
      server_traffic_control_enabled_eq_disabled: 'Desahabilitado',
      server_traffic_control_enabled_eq_enabled: 'Habilitado',
      service_dgo_eq: 'Servicio Directv Go',
      service_dgo_eq_both: 'Ambos',
      service_dgo_eq_disabled: 'Deshabilitado',
      service_dgo_eq_enabled: 'Habilitado',
      service_mikrotik_server_id: 'Servidor DHCP',
      service_olt_ont_offline_without_disabled_deactivated_and_navigation_control:
        'ONUs offline (sin contratos deshabilitados con control de navegación)',
      service_olt_ont_with_error_rules: 'ONUs con cambios fallidos',
      service_olt_ont_with_pending_rules: 'ONUs con cambios pendientes',
      service_wispro_box_acs_eq: 'ACS',
      service_wispro_box_acs_eq_both: 'Ambos',
      service_wispro_box_acs_eq_disabled: 'Deshabilitado',
      service_wispro_box_acs_eq_enabled: 'Habilitado',
      service_wispro_box_eq: 'WisproBox',
      service_wispro_box_eq_both: 'Ambos',
      service_wispro_box_eq_disabled: 'Deshabilitado',
      service_wispro_box_eq_enabled: 'Habilitado',
      start_date: 'Fecha de alta',
      state_eq_any: `Contrato: (Estado)`,
      state_eq_any_alerted: 'Alertado',
      state_eq_any_degraded: 'Degradado',
      state_eq_any_disabled: 'Deshabilitado',
      state_eq_any_enabled: 'Habilitado',
      table_header_tooltip_color_disabled: 'Facturación Deshabilitada',
      table_header_tooltip_color_generated: 'Facturación Habilitaba, Podrá generar Facturas de servicio.',
      table_header_tooltip_color_not_generated:
        'Facturación Habilitada, Generar Factura inicial y Cancelar Factura Inicial',
      table_header_tooltip_invoicing_cancel_initial_invoice:
        '<0/>: Anule la factura inicial antes de su emisión. Acción irreversible.',
      table_header_tooltip_invoicing_discount:
        'Muestra la cantidad de Items de Descuentos activos en el contrato, podrá actualizarlos editando el contrato en la pestaña de facturación.',
      table_header_tooltip_invoicing_generate_initial_invoice:
        '<0/>: Inicie el ciclo de facturación con un formulario detallado.',
      table_header_tooltip_invoicing_generate_service_invoice: '<0/>: Disponible tras crear la factura inicial.',
      table_header_tooltip_invoicing_payment_promise:
        'Indica la cantidad de Promesas de pago activas asignadas a este contrato. Cliqueando el icono se proporcionará acceso al menú de Promesas de pago para la gestión de las mismas.',
      table_header_tooltip_invoicing_recurring_item:
        'Muestra la cantidad de Items recurrentes activos en el contrato, podrá actualizarlos editando el contrato en la pestaña de facturación.',
      table_header_tooltip_invoicing_view_invoicing_info:
        '<0/>: Consulte detalles y configuraciones de su perfil de facturación.',
      table_header_tooltip_ont_nap_port_subtitle:
        ' Visualice y copie el nombre del puerto NAP al que esta conectado el contrato.',
      table_header_tooltip_ont_nap_subtitle:
        'Desplace el cursor sobre este ícono para ver la NAP previamente asignada a una OLT en el contrato.',
      table_header_tooltip_ont_olt_linked:
        '<0>El contrato se encuentra relacionada con una ONU:</0> Acciones posibles: ',
      table_header_tooltip_ont_olt_not_linked: '<0>La OLT no se encuentra vinculada</0>',
      table_header_tooltip_ont_olt_not_pending_cfg:
        '<0> El contrato no se encuentra relacionada con una ONU:</0> Acciones posibles:',
      table_header_tooltip_ont_ont_subtitle: 'Acciones para la ONU según el estado',
      table_header_tooltip_ont_ont_subtitle_2: 'Estado de cambios en la ONU',
      table_header_tooltip_ont_ont_title: 'Columna de ONU/NAP/Precintos',
      table_header_tooltip_ont_seal_subtitle:
        ' Visualice y copie el código del precinto asignado al contrato de forma rápida y sencilla.',
      table_header_tooltip_ont_unsync: '<0>La ONU no se encuentra sincronizada:</0> Acciones posibles:',
      table_header_tooltip_ont_w_config:
        '<0>Contrato relacionado con la ONU en modo link (Relacionada utilizando la configuración preexistente en la olt).</0> Acciones NO soportadas:',
      table_header_tooltip_ont_w_onlylink_hint:
        '<0>Contrato relacionado con la ONU en modo NO link (Relacionada y autorizada con la configuración de Wispro)</0>',
      table_header_tooltip_ont_w_onlylink_qoute: 'Puede vincular la ONU sin perder su configuracion preexistente',
      table_header_tooltip_ont_with_error_rules: '<0>Ocurrieron errores al aplicar cambios en la ONU<0/>',
      table_header_tooltip_ont_with_pending_rules: '<0>Se estan aplicando cambios en la ONU<0/>',
      tcp_prio_ports: 'Puertos TCP que obtendrán prioridad',
      to_be_disabled_between: 'Vencimiento (Fechas)',
      udp_prio_ports: 'Puertos UDP que obtendrán prioridad',
      wifi_password: 'Contraseña Wifi',
      with_active_recurring_items_for_kind_id: 'Item Recurrente',
      with_clients_with_pending_invoices: 'De clientes con facturas pendientes',
      with_discounts_to_apply: 'Con descuento',
      with_generation_error: 'Con error de generación',
      with_manually_modified_price: 'Precio modificado manualmente',
      with_pending_invoices: 'Con facturas pendientes',
      with_valid_payment_promises: 'Con promesas de pago activas',
      with_zero_balance: 'Con balance en cero',
      without_discounts_to_apply: 'Sin descuento',
      without_initial_invoice: 'Sin factura inicial',
      without_invoices_current_period: 'Sin facturas del período'
    },
    coverage: {
      contracts_count: 'Contratos'
    },
    dashboard: {
      download: 'Bajada',
      month: 'Mes',
      upload: 'Subida',
      year2: 'Año'
    },
    dgo: {
      pack: {
        urn: 'URN',
        tax_percentage: 'Impuesto (%)',
        next_discount_percentage: 'Próximo descuento (%)',
        next_date: 'Próxima fecha',
        discount_period: 'Período de descuento',
        next_discount_period: 'Próximo período de descuento',
        discount_percentage_scale: 'Escala de descuento (%)',
        next_discount_percentage_scale: 'Próxima escala de descuento (%)',
        kind_premium: 'Premium'
      },
      subscription: {
        changed_basic_pack_at: 'Pack básico cambiado el',
        external_reference: 'Referencia externa'
      },
      service: {
        pack_id: 'Pack',
        discount_period: 'Período de descuento',
        count_applied_discount_period: 'Períodos de descuento aplicados',
        discount_percentage_scale: 'Escala de descuento (%)',
        state_to_cancelled: 'Por cancelar',
        state_cancelled: 'Cancelado',
        state_to_active: 'Por activar'
      },
      transaction: {
        service_id: 'Servicio',
        end_date: 'Fecha de fin',
        tax_percentage: 'Impuesto (%)',
        invoice_id: 'Factura',
        item_id: 'Ítem',
        authorized_at: 'Fecha de autorización',
        conciliation_id: 'Conciliación',
        paid_at: 'Fecha de pago'
      }
    },
    dhcp_server: {
      name: 'Nombre',
      kind: 'Tipo',
      user: 'Usuario',
      password: 'Contraseña',
      mikrotik_use_ssl: 'API-SSL',
      host: 'Host',
      port: 'Puerto',
      link_status: 'Vinculación',
      contracts_count: 'Contratos',
      last_seen: 'Última vez visto',
      lease_time: 'Duración de asignación'
    },
    disk: {
      prepare_disk_for: 'Asignar disco a',
      prepare_disk_for_cache: 'Asignar el disco a cache',
      serial: 'Num de serie'
    },
    employee: {
      public_key: 'RSA Pública',
      user_email: 'Email del usuario',
      user_password: 'Contraseña',
      user_password_confirmation: 'Confirmar contraseña',
      user_public_key: 'Llave publica',
      user: {
        password_confirmation: 'Confirmar contraseña',
        public_key: 'Llave publica',
        role_ids: [
          'Roles',
          {
            admin: 'Admin',
            administrative: 'Administrativo',
            administrative_read_only: 'Administrativo de solo lectura',
            administrative_supervisor: 'Supervisor administrativo',
            administrative_supervisor_read_only: 'Supervisor administrativo de solo lectura',
            collector: 'Recaudador',
            collector_read_only: 'Recaudador de solo lectura',
            external_technician: 'Técnico externo',
            general_manager: 'Manager general',
            general_manager_read_only: 'Manager general de solo lectura',
            helpdesk: 'Mesa de ayuda',
            helpdesk_read_only: 'Mesa de ayuda de solo lectura',
            helpdesk_supervisor: 'Supervisor de mesa de ayuda',
            helpdesk_supervisor_read_only: 'Supervisor de mesa de ayuda de solo lectura',
            installer: 'Instalador',
            installer_read_only: 'Instalador de solo lectura',
            installer_supervisor: 'Supervisor de instalaciones',
            installer_supervisor_read_only: 'Supervisor de instalaciones de solo lectura',
            owner: 'Dueño',
            sale_desk: 'Mesa de ventas',
            sale_desk_read_only: 'Mesa de ventas de solo lectura',
            sale_desk_supervisor: 'Supervisor de mesa de ventas',
            sale_desk_supervisor_read_only: 'Supervisor de mesa de ventas de solo lectura',
            seller_read_only: 'Vendedor de solo lectura',
            seller: 'Vendedor',
            support: 'Soporte',
            technician: 'Técnico',
            technician_read_only: 'Técnico de solo lectura',
            technician_supervisor: 'Supervisor técnico',
            technician_supervisor_read_only: 'Supervisor técnico de solo lectura'
          }
        ]
      },
      user_zones: 'Zonas',
      zones: 'Zonas'
    },
    feedback: {
      kind: 'Tipo de Feedback',
      kind_feedback: 'Tipo de Feedback'
    },
    freeradius_client: {
      secret: 'Secreto'
    },
    frecuency: {
      ['1']: 'Mensual',
      ['2']: 'Bimestral',
      ['3']: 'Trimestral',
      ['4']: 'Cuatrimestral',
      ['6']: 'Semestral',
      ['12']: 'Anual'
    },
    forwarded_port: {
      address_id: 'Dirección',
      interface_id: 'Interfaz',
      private_port: 'Puerto privado',
      provider_id: 'Proveedor',
      public_port: 'Puerto público',
      server_configuration_id: 'Servidor',
      tcp: 'TCP',
      udp: 'UDP'
    },
    gps_point: {
      additional_data: 'Datos adicionales',
      city: 'Ciudad',
      country: 'País',
      heading: 'Orientación',
      latitude: 'Latitud',
      longitude: 'Longitud',
      name: 'Nombre',
      number: 'Número',
      pitch: 'Inclinación',
      placeable_id: 'Asociado a',
      pov_lat: 'Latitud de vista',
      pov_lng: 'Longitud de vista',
      state: 'Provincia',
      street: 'Calle',
      zoom: 'Zoom'
    },
    help_desk: {
      issue: {
        assignable_id: 'Asignado a',
        help_desk_issue_category_id: 'Categoría',
        main_help_desk_issue_category_id: 'Categoría principal',
        assigned_at: 'Fecha de asignación'
      }
    },
    helpdesk: {
      issue: {
        all_issues: 'Todos los tickets',
        assignable: 'Asignado a',
        assignable_id: 'Asignado a',
        assignable_type: 'Tipo',
        assigned_at: 'Asignado el',
        assigned_to: 'Asignado a',
        states: {
          pending: 'Pendiente',
          assigned: 'Asignado',
          finalized: 'Finalizado',
          closed: 'Cerrado',
          reopened: 'Reabierto'
        },
        client_custom_id_eq: 'ID Cliente personalizable',
        client_national_identification_number_cont: 'Documento ó Cédula de identidad',
        client_state_eq: 'Provincia/Estado/Región',
        complexity_eq_any_high: 'Alta',
        complexity_eq_any_medium: 'Media',
        complexity_eq_any_low: 'Baja',
        complexity_eq_any: 'Complejidad',
        contract_cable_modem_enabled_true: 'Habilitado',
        contract_cable_modem_enabled_false: 'Deshabilitado',
        contract_cable_modem_enabled_both: 'Ambos',
        contract_dhcp_enabled_true: 'Habilitado',
        contract_dhcp_enabled_false: 'Deshabilitado',
        contract_dhcp_enabled_both: 'Ambos',
        contract_public_address_id_null_present: 'Presente',
        contract_public_address_id_null_not_present: 'No Presente',
        contract_public_address_id_null_both: 'Ambos',
        contract_pppoe_enabled_true: 'Habilitado',
        contract_pppoe_enabled_false: 'Deshabilitado',
        contract_pppoe_enabled_both: 'Ambos',
        contract_sequential_id: 'ID Contrato',
        created_at_gteq: 'Creado el (desde)',
        created_at_lteq: 'Creado el (hasta)',
        expires_at: 'Vencimiento',
        expires_at_gteq: 'Vencimiento el (desde)',
        expires_at_lteq: 'Vencimiento el (hasta)',
        help_desk_issue_category_id: 'Categoría',
        issue_category: 'Categoría',
        main_category: 'Categoría principal',
        main_help_desk_issue_category_id: 'Categoría principal',
        mobile_true: 'Aplicación Móvil',
        mobile_false: 'Manual',
        mobile_both: 'Ambos',
        mobile_eq: 'Aplicación Móvil',
        only_my_issues: 'Solo mis tickets',
        priority_eq_any_high: 'Alta',
        priority_eq_any_medium: 'Media',
        priority_eq_any_low: 'Baja',
        priority_eq_any: 'Prioridad',
        secondary_category: 'Categoría secundaria',
        sequential_id: 'Número de ticket',
        state_pending: 'Pendiente',
        state_assigned: 'Asignado',
        state_finalized: 'Finalizado',
        state_closed: 'Cerrado',
        state_reopened: 'Reabierto',
        to_be_invoiced: 'A facturar',
        to_be_invoiced_true: 'A facturar',
        to_be_invoiced_false: 'No facturar',
        to_be_invoiced_both: 'Ambos',
        to_be_invoiced_eq: 'A facturar',
        uniq_code_numeric: {
          add_cun: 'Agregar CUN',
          assign_cun: 'Asignar CUN',
          base_code: 'Código base',
          create_format_cun: 'Crear nuevo formato CUN',
          cun: 'CUN',
          custom_no_record_title: 'No hay Formatos CUN para mostrar',
          default_type: 'Tipo de formato',
          edit_format_cun: 'Editar formato CUN',
          format_cun: 'Formato número CUN',
          length_code: 'Longitud del código',
          prefix: 'Prefijo',
          separator: 'Separador',
          sequential_code: 'Código secuencial',
          sufix: 'Sufijo',
          tickets_with_cun: 'Tickets con CUN',
          type_code: 'Tipo de código'
        },
        viewed_true: 'Visto',
        viewed_false: 'No visto',
        viewed_both: 'Ambos',
        viewed_eq: 'Visto'
      },
      issue_category: {
        help_desk_issues: 'Tickets'
      }
    },
    hola_notification: {
      automatics: 'Automáticas',
      text: 'texto',
      automatic_notifications: {
        activate_automatic_notification_tooltip:
          'Para activar notificaciones automáticas debes configurar una Plantilla',
        banner: {
          config_hint: 'Configurar cómo se envían las notificaciones a tus clientes, selecciona plantilla y listo.',
          power_hint: 'Activar/desactivar el envío automático según tus necesidades.',
          title: 'Desde esta sección puedes'
        },
        channels: {
          activate_automatic_notification: 'Para activar notificaciones automáticas debes configurar un Canal'
        },
        kind: {
          client_created: 'Enviar mensajes cuando se cree un cliente',
          contract_disabled: 'Enviar mensajes cuando se deshabilite un contrato',
          dgo_subscription_created: 'Enviar mensajes cuando se cree una suscripción de DGO',
          issued_invoice: 'Enviar mensajes cuando se emita la factura',
          order_finalized: 'Esta te la confirmo más tarde',
          order_scheduled: 'Enviar mensajes cuando se programe una visita',
          payment_created: 'Enviar mensajes cuando se cree un pago'
        },
        template: {
          activate_automatic_notification: 'Para activar notificaciones automáticas debes configurar un Template',
          no_results: 'No hay Templates para mostrar',
          no_templates_available: 'No hay Plantillas disponibles',
          search_template: 'Buscar Template...'
        },
        you_must_activate_the_service_to_continue_with_the_setup:
          'Debes activar el servicio para continuar con la configuración'
      },
      client_notifications: {
        kind: {
          client_created: 'Bienvenida',
          contract_disabled: 'Contrato deshabilitado',
          dgo_subscription_created: 'Suscripción a DGO creada',
          issued_invoice: 'Factura emitida',
          payment_created: 'Pago creado'
        },
        status: {
          sent: 'Enviada'
        }
      },
      template_configurations: {
        form: {
          template_hola: 'Template',
          channel: 'Canal',
          title: {
            create_template_configuration: 'Crear Plantilla',
            edit_template_configuration: 'Editar Plantilla'
          }
        },
        create_template_configuration: 'Crear Plantilla',
        create_templates: 'Crear Plantillas',
        there_are_no_templates: 'No hay Plantillas para mostrar'
      },
      manual_notifications: {}
    },
    installation_order: {
      assigned_date: 'Fecha Asignada',
      coverage_id: 'Cobertura',
      gps_point_id: 'Punto GPS',
      installation_date: 'Fecha de instalación',
      nap_id: 'ID NAP',
      order_state_id: 'ID del Estado de la orden'
    },
    installation_order_configuration: {
      email: 'Correo de contacto',
      phone: 'Teléfono fijo de contacto'
    },
    installation_order_event: {
      end_at: 'Finaliza el',
      start_at: 'Programada el'
    },
    interface: {
      addresses: 'Direcciones',
      auto_detected_as: 'Auto detect (Interfaz)',
      included_in: 'Incluido en',
      kind: 'Tipo',
      link: 'Enlace',
      name: 'Nombre'
    },
    inventory: {
      auto_detected_as: 'Auto detect (Interfaz)',
      article: {
        product_code: 'Código de Producto ',
        serial_number: 'Número de serie',
        state_free: 'Libre',
        state_engaged: 'Comprometido',
        state_assigned: 'Asignado',
        state_broken: 'Roto',
        state_dropped: 'Dado de baja',
        state_stolen: 'Robado'
      },
      dealer: {
        product_catalog: 'Catálogo de producto'
      },
      movement: {
        destiny: 'Destino',
        destiny_type: 'Tipo de destino',
        kind: 'Tipo de movimiento',
        kind_transition: 'Transición',
        kind_entry: 'Entrada',
        kind_exit: 'Salida',
        previous_destiny_type: 'Tipo de destino anterior',
        previous_destiny_id: 'Destino anterior',
        quantity: 'Cantidad'
      },
      stock: {
        maxstock: 'Stock máximo',
        minstock: 'Stock mínimo',
        default_article_user: 'Usuario por defecto del artículo',
        default_article_pass: 'Contraseña por defecto del artículo',
        stock_image_content_type: 'Tipo de contenido de la imagen',
        classification: 'Clasificación',
        classification_other: 'Otro',
        classification_router: 'Router',
        classification_switch: 'Switch',
        classification_modem: 'Módem',
        classification_antenna: 'Antena',
        classification_repeater: 'Repetidor',
        classification_access_point: 'Punto de acceso'
      }
    },
    invoicing: {
      abstract_invoice: {
        base_invoiced_date: 'Fecha de inicio del periodo',
        client_address: 'Dirección del cliente',
        client_national_identification_number: 'Número de identificación del cliente',
        client_payment_way: 'Forma de Pago',
        client_taxpayer_identification_number: 'Número de identificación fiscal del cliente',
        client_vat_condition: 'Cond. Iva (cliente)',
        firm_address: 'Dirección (Razón Social)',
        firm_company_name: 'Nombre de la empresa',
        firm_email: 'Email (Razón Social)',
        firm_gross_income: 'Ingresos brutos (Razón Social)',
        firm_phone: 'Teléfono (Razón Social)',
        firm_principal_activity: 'Actividad principal (Razón Social)',
        firm_sale_point: 'Punto de venta (Razón Social)',
        firm_start_activities_date: 'Fecha de inicio de actividades (Razón Social)',
        firm_taxpayer_identification_number: 'Número de identificación fiscal (Razón Social)',
        firm_vat_condition: 'Condición de IVA (Razón Social)',
        firm_zip: 'Código postal (Razón Social)',
        firm_zip_code: 'Código postal (Razón Social)',
        first_due_date: 'Primera fecha de vencimiento',
        id: 'Monto ID',
        interest_second_due_date: 'Interes del segundo vencimiento',
        invoicing_abstract_invoice_id: 'Factura (ID)',
        invoicing_concept: 'Concepto de facturación',
        invoicing_invoicing_firm_id: 'Razón social (ID)',
        issue_state: 'Estado',
        issue_states: {
          issued: 'Emitida',
          issuing: 'Emitiendo',
          not_issued: 'No Emitida'
        },
        limit_invoiced_date: 'Fecha límite del periodo',
        second_due_date: 'Segunda fecha de vencimiento',
        surcharge_for_first_due_date: 'Recargo 1º venc',
        surcharge_for_second_due_date: 'Recargo 2º venc'
      },
      cash_audit: {
        cash_audit_id: 'ID Arqueo de Caja',
        creatable_id: 'Creado por',
        creatable_type: 'Tipo',
        created_by: 'Creado por',
        transactions: 'Transacciones'
      },
      client: {
        link_payments: 'Código LinkPagos',
        additional_one: 'Información adicional',
        additional_two: 'Información adicional 2',
        balance_amount: 'Monto de Balance',
        client_gateway_alias: 'Alias',
        client_gateway_cbu: 'CBU',
        argentina: {
          client_gateway_id: 'Nº cliente',
          cobro_digital_pago_mis_cuentas: 'Código PagoMisCuentas',
          digital_barcode: 'Código de barra del Cliente',
          taxpayer_identification_number: 'CUIT/CUIL',
          vat_condition: 'Condición de IVA'
        },
        authorize_invoice_after_paid: 'Informar después de pagar',
        automatic_state: 'Estado automático',
        colombia: {
          sale_point_town: 'Municipio',
          tax_responsibility: 'Responsabilidad Fiscal',
          taxpayer_identification_number: 'CC/CE/NIT',
          vat_condition: 'Régimen'
        },
        concept: 'Uso de CFDI',
        costa_rica: {
          taxpayer_identification_number: 'Num de ident. tributaria',
          vat_condition: 'Condición de IVA'
        },
        device_token: 'Token de dispositivo',
        ecuador: {
          taxpayer_identification_number: 'Cédula/RUC',
          vat_condition: 'Régimen'
        },
        emails_to_notify: 'Emails a notificar',
        generic: {
          client_gateway_id: 'Nº cliente en pasarela',
          taxpayer_identification_number: 'Num de ident. tributaria'
        },
        invoicing_enabled: 'Facturación',
        invoicing_enabled_title_for_check: 'Habilitar Facturación',
        invoicing_firm: 'Razón Social',
        mexico: {
          taxpayer_identification_number: 'RFC',
          vat_condition: 'Régimen',
          invoicing_name: 'Nombre / Razón social'
        },
        next_period: 'No facturar este periodo, facturar a partir del proximo',
        partial_period: 'Cobrar proporcional desde el día seleccionado',
        panama: {
          taxpayer_identification_number: 'NIT',
          vat_condition: 'Régimen'
        },
        peru: {
          vat_condition: 'Tipo de persona a facturar',
          taxpayer_identification_number: 'RUC',
          invoicing_name: 'Nombre/Razón social'
        },
        payment_way: 'Forma de Pago',
        send_email_when_create_payment: 'Enviar correo cuando se crea un pago',
        send_email_when_issue_invoices: 'Enviar correo con factura emitida',
        start_invoicing_day: 'Ciclo de facturación comienza el día',
        tax_one: 'Impuesto',
        tax_one_id: 'Impuesto',
        taxpayer_identification_number: 'Número de identificación tributaria',
        total_period: 'Generar la factura ahora y cobrar el periodo completo',
        bar_code_file_name: 'Archivo de código de barras',
        invoicing_tax_one_id: 'Impuesto (ID)',
        kind_person_mexico_natural: 'Persona física',
        kind_person_mexico_juridic: 'Persona moral'
      },
      clients_payment_gateway: {
        client_gateway_id: 'Nº cliente',
        cobro_digital_pago_mis_cuentas: 'Código PagoMisCuentas',
        current_number_in_gateway: 'Número actual en pasarela',
        deleted_at: 'Eliminado el',
        digital_barcode: 'Código de barra del Cliente',
        invoicing_payment_gateway: 'Pasarela de pago',
        invoicing_payment_gateway_id: 'Pasarela de pago',
        link_payments: 'Código LinkPagos',
        payment_gateway: 'Pasarela de pago',
        total_period: 'Generar la factura ahora y cobrar el periodo completo',
        without_payment_gateway_filter: 'Sin pasarela de pago',
        ipg_issue_enabled: 'Emisión en pasarela habilitada'
      },
      concept: {
        mexico: {
          commodity: 'G01 - Adquisición de mercancías',
          returns_discounts_bonuses: 'G02 - Devoluciones, descuentos o bonificaciones',
          general_expenses: 'G03 - Gastos en general',
          buildings: 'I01 - Construcciones',
          furniture_and_office_equipment_for_investments: 'I02 - Mobiliario y equipo de oficina por inversiones',
          transportation_equipment: 'I03 - Equipo de transporte',
          computer_equipment_and_accessories: 'I04 - Equipo de computo y accesorios',
          craps_dies_molds_matrixes_and_tooling: 'I05 - Dados, troqueles, moldes, matrices y herramental',
          telephone_communications: 'I06 - Comunicaciones telefónicas',
          satellite_communications: 'I07 - Comunicaciones satelitales',
          other_machinery_and_equipment: 'I08 - Otra maquinaria y equipo',
          medical_fee_dental_and_hospital_expenses: 'D01 - Honorarios médicos, dentales y gastos hospitalarios',
          medical_expenses_due_to_incapacity: 'D02 - Gastos médicos por incapacidad o discapacidad',
          funeral_expenses: 'D03 - Gastos funerales',
          donations: 'D04 - Donativos',
          interest_paid_for_mortgage_loans:
            'D05 - Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación)',
          voluntary_contributions_to_SAR: 'D06 - Aportaciones voluntarias al SAR',
          medical_expense_insurance: 'D07 - Primas por seguros de gastos médicos',
          school_transportation_expenses: 'D08 - Gastos de transportación escolar obligatoria',
          deposits_in_savings_accounts_based_on_pension_plans:
            'D09 - Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones',
          payments_for_educational_services: 'D10 - Pagos por servicios educativos (colegiaturas)',
          no_tax_effects: 'S01 - Sin efectos fiscales',
          payments: 'CP01 - Pagos',
          paysheet: 'CN01 - Nómina',
          to_define_cfdi: 'P01 - Por definir'
        }
      },
      contract: {
        alerted_date_by_system: 'Alertado automaticamente el',
        auto_invoice_issuing: 'Emisión de facturas automáticas',
        automatic_state: 'Estado automático',
        available_promises: 'Promesas disponibles',
        base_invoiced_date: 'Fecha inicio periodo facturado',
        charge_in_advance: 'Cobro por adelantado',
        corporate_name: 'Razón social',
        current_period_invoiced: 'Ultimo periodo facturado',
        days_for_first_due: 'Días para el 1º vencimiento',
        days_for_second_due: 'Días para el 2º vencimiento',
        days_to_alert_contract: 'Días para cambiar el estado a avisado',
        days_to_disable_contract: 'Días para cambiar el estado a deshabilitado',
        delinquent_date_by_system: 'Moroso automáticamente el',
        disabled_date_by_system: 'Deshabilitado automaticamente el',
        due_one_interest: 'Interés para el 1º vencimiento',
        due_two_interest: 'Interés para el 2º vencimiento',
        electronic_enabled: 'Electrónica',
        generate_reconnection_charge: 'Generar recargo por conexión',
        initial_invoice_generated: 'Factura inicial generada',
        invoice_day: 'Día a facturar',
        invoice_generation_error: 'Error de generación de factura',
        invoicing_plan_id: 'Plan',
        invoicing_profile_id: 'Perfil de facturación',
        limit_invoiced_date: 'Fecha fin periodo facturado',
        next_period: 'No facturar este periodo, facturar a partir del proximo',
        next_period_to_invoice: 'Proximo periodo a facturar',
        not_invoice_when_is_disabled: 'No generar factura cuando esta deshabilitado',
        partial_period: 'Generar la factura ahora y cobrar proporcional desde el día seleccionado',
        profile: 'Perfil de facturación',
        reconnection_surcharge: 'Recargo por reconexión',
        reconnection_surcharge_not_generate: 'No generar',
        reconnection_surcharge_to_generate: 'A generar',
        reconnection_surcharge_to_process: 'A procesar',
        reconnection_surcharged_at: 'Recargo el',
        second_due_date_at_end_of_period: 'Segundo venc. al finalizar el periodo',
        start_invoicing_date: 'Fecha inicio facturación',
        strategy_to_alert_contract: 'Cambiar estado a avisado',
        strategy_to_disable_contract: 'Cambiar estado a deshabilitado',
        tax_one: 'Impuesto',
        tax_one_id: 'Impuesto',
        taxpayer_identification_number: 'Num. de identificación tributaria',
        total_period: 'Generar la factura ahora y cobrar el periodo completo',
        deleted_at: 'Eliminado el',
        frecuency: 'Frecuencia',
        price: 'Precio',
        social_stratum: 'Estrato social',
        state: 'Estado',
        use_information_contract_for_invoice: 'Definir info. tributaria'
      },
      contract_discount: {
        activation_date: 'Fecha de activación',
        amount: 'Monto',
        contract_discount_edition_enabled: 'Habilitar edición de periodos al asignar descuento',
        count_applied_lapse: 'Periodos aplicados',
        discount: 'Descuento',
        discountable_type: 'Aplica a',
        discountable_id: 'Identificador asociado',
        ends_at: 'Fecha de fin',
        invoicing_discount_id: 'Descuento',
        kind: 'Tipo',
        kind_other: 'Otro',
        kind_loyalty: 'Fidelidad',
        kind_retention: 'Retención',
        kind_new_client: 'Nuevo cliente',
        lapse: 'Periodos',
        name: 'Nombre',
        starts_at: 'Fecha de inicio',
        state: 'Estado',
        strategy: 'Estrategia',
        states: {
          pending: 'Pendiente',
          applying: 'Aplicando',
          applied: 'Aplicado',
          canceled: 'Cancelado'
        }
      },
      credit_note: {
        category_placeholder: 'Seleccione categorías',
        amount: 'Monto',
        amount_available: 'Monto disponible',
        amount_voided: 'Monto anulado',
        amount_to_void: 'Monto anular',
        credit_note_created_successfuly: 'Se creó la nota de crédito',
        credit_note_created_error: 'Error al crear la nota de crédito',
        total_to_avoid_min_validation: 'El monto no puede ser negativo',
        total_to_avoid_max_validation: 'No puede superar el monto disponible {{ amount }}',
        cant_edit_default_category: 'No puede editar la categoría por defecto',
        category_by_default: 'Categoría por defecto',
        total_credit_notes_column: 'Notas de crédito asignadas',
        invoicing_invoicing_firm_id: 'Razón Social',
        invoicing_abstract_invoice_id: 'Factura original',
        interest_first_due_date: 'Interés 1º venc. (Monto)',
        interest_second_due_date: 'Interés 2º venc. (Monto)',
        first_due_date: '1º venc.',
        second_due_date: '2º venc.',
        base_invoiced_date: 'Inicio periodo',
        limit_invoiced_date: 'Fin periodo',
        firm_start_activities_date: 'Inicio actividades (Razón Social)',
        issuing_feedback: 'Feedback',
        firm_email: 'Email (Razón Social)',
        firm_phone: 'Tel (Razón Social)',
        firm_address: 'Dirección (Razón Social)',
        firm_country: 'País (Razón Social)',
        firm_locality: 'Localidad (Razón Social)',
        firm_zip_code: 'Cod. postal (Razón Social)',
        corporate_name: 'Nombre compañía',
        client_address: 'Dirección (Cliente)',
        firm_sale_point: 'Punto de venta (Razón Social)',
        firm_gross_income: 'Ing. Brutos (Razón Social)',
        firm_company_name: 'Nom. Compañía (Razón Social)',
        firm_vat_condition: 'Cond. IVA (Razón Social)',
        client_vat_condition: 'Cond. IVA (cliente)',
        firm_principal_activity: 'Act. principal (Razón Social)',
        firm_taxpayer_identification_number: 'Identificación fiscal (Razón Social)',
        client_taxpayer_identification_number: 'Identificación fiscal (cliente)',
        client_national_identification_number: 'Identificación nacional (cliente)',
        electronic_invoice_generated: 'Factura electrónica generada',
        count_pre_print: 'Pre-impresa contador',
        credit_note_number: 'Num. Nota de crédito',
        surcharge_for_first_due_date: 'Recargo 1º venc',
        surcharge_for_second_due_date: 'Recargo 2º venc',
        client_payment_method: 'Método de Pago',
        client_payment_way: 'Forma de Pago',
        authorization_state: 'Estado de autorización',
        authorization_state_not_authorized: 'No autorizado',
        authorization_state_authorizing: 'Autorizando',
        authorization_state_authorizing_error: 'Error de autorización',
        authorization_state_authorized: 'Autorizado',
        issue_state: 'Estado de emisión',
        issue_state_not_issued: 'No emitida',
        issue_state_issuing: 'Emitiendo',
        issue_state_issued: 'Emitida',
        state_completed: 'Completado',
        invoicing_concept: 'Concepto de facturación',
        use_net_amount: 'Usar monto neto',
        authorized_at: 'Autorizada el',
        should_generate_coupons: 'Generar cupones'
      },
      credit_note_pool_number: {
        current: 'En uso',
        expire_at: 'Fecha de expiración'
      },
      current_account: {
        balance_amount: 'Balance',
        balance: 'Balance C/C',
        credit_amount: 'Crédito',
        credit: 'Crédito disponible',
        invoice_balance_amount: 'Saldo facturado',
        invoice_balance: 'Facturas impagas',
        lock_version: 'Versión bloqueada'
      },
      discount: {
        amount: 'Monto',
        contract_discount_edition_enabled: 'Habilitar edición de periodos al asignar descuento',
        description: 'Descripción',
        expire_behavior: 'Comportamiento al expirar',
        expires_at: 'Expira el',
        fixed_amount: 'Monto fijo',
        kind: 'Tipo',
        kind_other: 'Otro',
        kind_loyalty: 'Fidelidad',
        kind_retention: 'Retención',
        kind_new_client: 'Nuevo cliente',
        lapse: 'Periodos',
        name: 'Nombre',
        percentage: 'Porcentaje',
        starts_at: 'Inicia el',
        strategy: 'Estrategia',
        validity_mode: 'Vigencia',
        kinds: {
          other: 'Otro',
          loyalty: 'Fidelidad',
          new_client: 'Nuevo cliente',
          retention: 'Retención'
        },
        states: {
          expired: 'Expirado',
          enabled: 'Habilitado',
          disabled: 'Deshabilitado'
        },
        validities: {
          with_validity: 'Con vigencia',
          without_validity: 'Sin vigencia'
        }
      },
      ecuador_einvoice: {
        access_code: 'Clave de acceso',
        auth_code: 'Código de autorización'
      },
      einvoice: {
        argentina: {
          cae: 'CAE',
          cae_due_date: 'Vencimiento CAE'
        },
        bill_number: 'Num. de factura',
        billed_date: 'Generado el',
        vat_total: 'Total IVA',
        invoicing_abstract_invoice_id: 'Factura',
        cae: 'CAE',
        cae_due_date: 'Vencimiento CAE',
        afip_request: 'Request AFIP',
        afip_response: 'Response AFIP'
      },
      invoice: {
        argentina: {
          client_national_identification_number: 'DNI (Cliente)',
          client_taxpayer_identification_number: 'CUIT/CUIL',
          client_vat_condition: 'Cond. Iva (cliente)',
          cobro_digital_bar_code_amount: 'Cod. Barra (CobroDigital)',
          cobro_digital_invoice_generated: 'Boleta generada cobroDigital',
          cobro_digital_ticket_number: 'Num. Ticket (CobroDigital)',
          firm_taxpayer_identification_number: 'CUIT/CUIL (Razón Social)',
          firm_vat_condition: 'Cond. Iva (Razón Social)'
        },
        authorization_state: 'Estado de autorización',
        authorize_invoice_after_paid: 'Informar después de pagar',
        base_invoiced_date: 'Inicio periodo',
        client_address: 'Dirección (Cliente)',
        client_payment_method: 'Método de Pago',
        client_payment_way: 'Forma de Pago',
        clients_payment_gateways: 'Pasarelas de pago del Cliente',
        corporate_name: 'Nombre compañía',
        count_pre_print: 'Pre-impresa contador',
        credit_note_number: 'Num. Nota de crédito',
        due_amount: 'Adeudado',
        electronic_enabled: 'Electrónica',
        firm_address: 'Dirección (Razón Social)',
        firm_company_name: 'Nom. Compañía (Razón Social)',
        firm_country: 'País (Razón Social)',
        firm_email: 'Email (Razón Social)',
        firm_gross_income: 'Ing. Brutos (Razón Social)',
        firm_locality: 'Localidad (Razón Social)',
        firm_phone: 'Tel (Razón Social)',
        firm_principal_activity: 'Act. principal (Razón Social)',
        firm_sale_point: 'Punto de venta (Razón Social)',
        firm_start_activities_date: 'Inicio actividades (Razón Social)',
        firm_zip_code: 'Cod. postal (Razón Social)',
        first_due_date: '1º venc.',
        interest_first_due_date: 'Interés 1º venc. (Monto)',
        interest_second_due_date: 'Interés 2º venc. (Monto)',
        invoice_number: 'Num. Factura',
        invoicing_firm: 'Razón Social',
        invoicing_invoicing_firm: 'Razón Social',
        invoicing_invoicing_firm_id: 'Razón social',
        issued: 'Emitida',
        issued_at: 'Emitido el',
        issuing_feedback: 'Feedback',
        kind_invoice: {
          argentina_a: 'Argentina (A)',
          argentina_b: 'Argentina (B)',
          argentina_c: 'Argentina (C)',
          colombia: 'Factura de Venta',
          credit_note: 'Nota de crédito',
          ecuador: 'Factura de Venta',
          espana: 'Spain',
          invoice: 'Factura',
          mexico: 'Factura de venta',
          voucher: 'Comprobante',
          peru_invoice: 'Factura de venta',
          peru_final_consumer_invoice: 'Boleta de venta'
        },
        limit_invoiced_date: 'Fin periodo',
        not_service: 'Manual',
        reconnection_charge: 'Recargo por conexión (Monto)',
        second_due_date: '2º venc.',
        state: {
          draft: 'Borrador',
          paid: 'Pagada',
          pending: 'Pendiente de pago',
          pending_with_first_due_date: 'Pendiente de pago con 1º vencimiento alcanzado',
          pending_with_second_due_date: 'Pendiente de pago con 2º vencimiento alcanzado',
          void: 'Anulada'
        },
        surcharge_for_first_due_date: 'Recargo 1º venc (Tipo)',
        surcharge_for_first_due_date_not_generate: 'No generar',
        surcharge_for_first_due_date_generate: 'Generar',
        surcharge_for_first_due_date_processed: 'Procesado',
        surcharge_for_first_due_date_canceled: 'Cancelado',
        surcharge_for_second_due_date: 'Recargo 2º venc (Tipo)',
        surcharge_for_second_due_date_not_generate: 'No generar',
        surcharge_for_second_due_date_generate: 'Generar',
        surcharge_for_second_due_date_processed: 'Procesado',
        surcharge_for_second_due_date_canceled: 'Cancelado',
        tax_reconnection_charge: 'Imp. Recargo por conexión',
        invoicing_abstract_invoice_id: 'Factura original',
        electronic_invoice_generated: 'Factura electrónica generada',
        invoicing_concept: 'Concepto de facturación',
        use_net_amount: 'Usar monto neto',
        authorized_at: 'Autorizada el',
        should_generate_coupons: 'Generar cupones',
        client_vat_condition: 'Cond. IVA (cliente)',
        firm_vat_condition: 'Cond. IVA (Razón Social)',
        firm_taxpayer_identification_number: 'Identificación fiscal (Razón Social)',
        client_taxpayer_identification_number: 'Identificación fiscal (cliente)',
        client_national_identification_number: 'Identificación nacional (cliente)',
        issue_state: 'Estado de emisión',
        issue_state_not_issued: 'No emitida',
        issue_state_issuing: 'Emitiendo',
        issue_state_issued: 'Emitida',
        state_draft: 'Borrador',
        state_pending: 'Pendiente de pago',
        state_paid: 'Pagada',
        state_void: 'Anulada'
      },
      invoice_item: {
        invoicing_abstract_invoice_id: 'Factura',
        kind: 'Item plantilla',
        unit_of_measure: 'Unidad de medida',
        invoicing_kind_id: 'Item plantilla',
        invoicing_invoice_item_id: 'Item de factura original',
        tax_one_rate: 'Tasa de impuesto',
        discount_amount_currency: 'Moneda del descuento',
        surcharge_at: 'Fecha de recargo',
        invoicing_recurring_item_id: 'Item recurrente',
        classification: 'Clasificación',
        classification_without_classification: 'Sin clasificación',
        classification_for_service: 'Servicio',
        classification_for_extra_days_service: 'Días extra de servicio',
        classification_for_surcharges: 'Recargos',
        classification_for_reconnection_charge: 'Cargo de reconexión',
        classification_for_recurring: 'Recurrente',
        classification_for_installation: 'Instalación',
        classification_for_tv_service_dgo: 'Servicio TV DGO'
      },
      invoice_item_kind: {
        discount_amount_currency: 'Moneda del descuento',
        invoicing_tax_one_id: 'Impuesto 1',
        lapse: 'Periodos',
        mount: 'Monto',
        propagate_changes: 'Propagar cambios',
        recurring: 'Recurrente'
      },
      invoice_pool_number: {
        current: 'En uso',
        expire_at: 'Fecha de expiración',
        resolution_date: 'Fecha de resolución',
        resolution_number: 'Resolución'
      },
      invoices_payment_gateway: {
        barcode: 'Código de barras',
        clients_payment_gateway_id: 'Pasarela de pago del cliente',
        invoicing_invoice_id: 'Factura',
        issue_feedback: 'Errores',
        preference_expire_at: 'Expira el',
        preference_url: 'Url de Pago',
        raw_transaction: 'Transacción completa',
        ticket_number: 'Ticket'
      },
      invoicing_configuration: {
        company_logo: 'Logo',
        company_logo_content_type: 'Tipo de imagen (Logo)',
        company_logo_file_name: 'Nombre del archivo (Logo)',
        company_logo_file_size: 'Tamaño del archivo (Logo)',
        company_logo_updated_at: 'Logo actualizado el',
        custom_legend_for_invoice: 'Leyenda para factura',
        custom_legend_for_invoice_hint: 'Leyenda a mostrar en el pie de las facturas',
        custom_payment_legend: 'Leyenda para detallar formas de pago y puntos de atención',
        debt_in_invoice: 'Incluir deuda de cliente en factura',
        inform_total_service_debt_to_payment_gateways: 'Informar deuda total de servicio a las pasarelas de pago',
        inform_total_service_debt_to_payment_gateways_hint:
          'La factura de servicio que se emita, se informará a las pasarelas de pago con el saldo de la suma de todas las facturas pendientes del contrato.',
        invoice_numbers_payment_receipts_enabled: 'Mostrar números de factura en los recibos de pago',
        payments_in_invoice: 'Incluir últimos pagos en factura',
        pos_receipt_width: 'Ancho del papel (mm)',
        pos_receipt_width_hint:
          'Configuración del ancho del papel de impresora PoS: Antes de usar la impresora puede configurar el ancho del papel.'
      },
      invoicing_firm: {
        argentina: {
          taxpayer_identification_number: 'CUIT/CUIL'
        },
        certificate: 'Certificado AFIP',
        certificate_expiration: 'Expiración del certificado',
        colombia: {
          service_password: 'Token Password',
          service_url: 'Endpoint (FactoryHKA)',
          service_user: 'Token Empresa',
          taxpayer_identification_number: 'CC/CE/NIT',
          use_pdfs_from_service: 'Enviar PDF de FactoryHKA',
          vat_condition: 'Régimen'
        },
        company_name: 'Nombre compañía',
        costa_rica: {
          taxpayer_identification_number: 'Num de ident. tributaria'
        },
        cumulative_amount: 'Monto acumulado',
        current_credit_note_number_argentina_a: 'Último num. de nota de credito Argentina A',
        current_credit_note_number_argentina_b: 'Último num. de nota de credito Argentina B',
        current_credit_note_number_argentina_c: 'Último num. de nota de credito Argentina C',
        current_credit_note_number_colombia: 'Último num. de nota de credito Colombia',
        current_credit_note_number_ecuador: 'Último num. de nota de credito Ecuador',
        current_credit_note_number_espana: 'Último num. de nota de credito España',
        current_credit_note_number_mexico: 'Último num. de nota de credito Mexico',
        current_credit_note_number_voucher: 'Último num. de nota de credito Comprobante',
        current_invoice_number_argentina_a: 'Último num. de factura Argentina A',
        current_invoice_number_argentina_b: 'Último num. de factura Argentina B',
        current_invoice_number_argentina_c: 'Último num. de factura Argentina C',
        current_invoice_number_colombia: 'Último num. de factura Colombia',
        current_invoice_number_ecuador: 'Último num. de factura Ecuador',
        current_invoice_number_espana: 'Último num. de factura España',
        current_invoice_number_mexico: 'Último num. de factura Mexico',
        current_invoice_number_voucher: 'Último num. de factura Comprobante',
        dynamic_data: 'Datos dinámicos',
        ecuador: {
          accounting: 'Obligado a llevar contabilidad',
          principal_activity: 'Nombre Comercial',
          pyme: 'Regimen Microempresa',
          retention_agent_number: 'Agente de Retención Resolución No.',
          rimpe: 'Régimen RIMPE',
          sale_point: 'Punto de Emisión',
          sale_point_address: 'Dirección del Establecimiento',
          sale_point_code: 'Código de Establecimiento',
          taxpayer_identification_number: 'RUC',
          vat_condition: 'Condición'
        },
        electronic_enabled: 'Facturación electrónica',
        electronic_validated: 'Cuenta electrónica validada',
        fm_certificate_number: 'Num. certificado (FacturacionModerna)',
        fm_logo: 'Logo ID (FacturacionModerna)',
        fm_tax_regime: 'Régimen impositivo (FacturacionModerna)',
        fm_wsdl: 'WSDL (FacturacionModerna)',
        generic: {
          taxpayer_identification_number: 'Num. Identificación tributaria'
        },
        gross_income: 'Ingresos brutos',
        invoice_provider_without_provider: 'Sin proveedor',
        invoice_provider_colombia_factory_hka: 'Factory HKA',
        invoice_provider_colombia_siigo: 'Siigo',
        invoice_provider_peru_nube_fact: 'NubeFacT',
        invoice_provider_ecuador_sri: 'SRI',
        invoice_provider_ecuador_contifico: 'Contifico',
        invoicing_invoicing_configuration_id: 'Configuración de facturación',
        limit_amount: 'Monto limite',
        locality: 'Localidad',
        mexico: {
          fm_certificate_number: 'Num. Certificado (fm)',
          fm_logo: 'Logo ID (fm)',
          fm_tax_regime: 'Impuesto regime (fm)',
          fm_wsdl: 'Wsdl (fm)',
          sale_point: 'Serie',
          service_password: 'Usuario contraseña (fm)',
          service_url: 'Endpoint (fm)',
          service_user: 'Usuario id (fm)',
          taxpayer_identification_number: 'RFC',
          use_pdfs_from_service: 'Usar PDFs de FacturacionModerna',
          vat_condition: 'Régimen'
        },
        principal_activity: 'Actividad principal',
        sale_point: 'Punto de venta',
        sale_point_address: 'Dirección del punto de venta',
        sale_point_code: 'Código del punto de venta',
        sale_point_country: 'País punto de venta',
        sale_point_postcode: 'Código postal punto de venta',
        sale_point_state: 'Estado punto de venta',
        sale_point_town: 'Ciudad punto de venta',
        service_password: 'Contraseña del servicio',
        service_url: 'URL del servicio',
        service_user: 'Usuario del servicio',
        start_activities_date: 'Inicio de actividades',
        use_pdfs_from_service: 'Usar PDFs del servicio',
        webservice_feedback: 'Feedback webservice',
        zip_code: 'Código postal'
      },
      invoicing_service_invoice: {
        from_day: 'Desde',
        to_day: 'Hasta',
        amount: 'Monto',
        installation_amount: 'Monto de instalación',
        charge_installation: 'Cobrar instalación?',
        auto_invoice_issuing: 'Auto emitir la factura'
      },
      isp: {
        company_logo: 'Logo del isp',
        company_logo_file_name: ' Nombre del archivo del logo del isp',
        company_logo_file_size: 'Tamaño del archivo del logo del isp',
        company_logo_updated_at: 'Logo del isp actualizado el',
        company_logo_content_type: 'Tipo de archivo del logo del isp',
        custom_legend_for_invoice: 'Leyenda para factura',
        custom_payment_legend: 'Leyenda para detallar formas de pago y puntos de atención',
        debt_in_invoice: 'Incluir deuda de cliente en factura',
        exchange_currency: 'Moneda de cambio',
        first_maturity: 'Notificación de primer vencimiento',
        inform_total_service_debt_to_payment_gateways: 'Informar deuda total de servicio a las pasarelas de pago',
        invoice_numbers_payment_receipts_enabled: 'Mostrar números de factura en los recibos de pago',
        invoicing_currency: 'Tipo de moneda',
        invoicing_currency_to_exchange_currency_rate: 'Tasa de cambio',
        payments_in_invoice: 'Incluir últimos pagos en factura',
        pos_receipt_width: 'Ancho del papel (mm)',
        prisma_current_file_number: 'Número secuencial ascendente único por archivo',
        prisma_n_establecimiento_master: 'Número establecimiento Mastercard',
        prisma_n_establecimiento_visa_credit: 'Número establecimiento VISA Crédito',
        prisma_n_establecimiento_visa_debit: 'Número establecimiento VISA Débito',
        run_daemon_invoicing_at: 'Ejecutar daemon de facturación a las',
        second_maturity: 'Notificación de segundo vencimiento',
        use_net_amount: 'Usar montos de facturación como valores netos'
      },
      item_tax: {
        code: 'Código',
        invoicing_tax_id: 'ID',
        rate: 'Tasa',
        taxable_id: 'ID',
        taxable_type: 'Tipo'
      },
      payment: {
        amount_entered: 'Monto',
        change: 'Cambio',
        collected_by: 'Recolectado por',
        collector_email: 'Email de Recaudador',
        created_at: 'Registrado el',
        created_at_gteq: 'Registrado el (desde)',
        created_at_lteq: 'Registrado el (hasta)',
        credit_amount: 'Crédito',
        email_collector: 'Email de recaudador',
        email_user: 'Email de usuario',
        invoices: 'Facturas Pendientes',
        lock_version: 'Versión de bloqueo',
        name_collector: 'Nombre de recaudador',
        name_user: 'Registrado por',
        pay_with_credit_current_account: 'Usar crédito de cuenta corriente',
        payment_date: 'Fecha de pago',
        payment_date_gteq: 'Fecha de pago (desde)',
        payment_date_lteq: 'Fecha de pago (hasta)',
        payment_transactions_filter_with: 'Con facturas asociadas',
        payment_transactions_filter_without: 'Sin facturas asociadas',
        payment_transactions_filter_both: 'Ambas',
        payment_transactions_filter: 'Facturas asociadas',
        pos_print_after_create: 'Imprimir (PoS) después de crear el pago',
        print_after_create: 'Imprimir después de crear el pago',
        registered_by: 'Registrado por',
        save_in_current_account: 'Guardar cambio en cuenta corriente',
        sequential_id: 'ID Pago',
        total_owed: 'Total adeudado',
        transaction_code: 'Código único de transacción',
        transaction_kind: 'Transacción',
        transaction_kind_id: 'Transacción (ID)'
      },
      payment_gateway: {
        integration_api_key: 'Integración API KEY',
        seed_code: 'Código semilla',
        account_id: 'ID de cuenta',
        api_extras: 'Datos extra de API',
        api_key: 'Api Key',
        api_login: 'Api Login',
        automatic_debit: 'Débito automático',
        bancolombia: {
          agreement_number: 'Número de convenio',
          nit: 'NIT'
        },
        cardnet: {
          account_id: 'Mcc',
          merchant_id: 'Cardnet Name'
        },
        cobro_digital: {
          cobro_digital_address_key: 'Dirección',
          cobro_digital_email_key: 'Email',
          cobro_digital_full_name_key: 'Nombre completo',
          cobro_digital_identifier_key: 'Identificador de cliente',
          cobro_digital_national_identifier_key: 'Nro. de documento',
          emit_hint_off:
            '  <0>Modo OFF:</0> Se informarán a CobroDigital con el 1er y 2do vencimiento de cada factura (según lo fijado en el perfil), y un 3er informe al fin del período (servicio de internet) o fin de mes (facturas manuales).',
          emit_hint_on:
            '  <0>Modo ON:</0>Se informará a CobroDigital igual que el "Modo OFF" con un vencimiento adicional a los 5 días             posteriores de la fecha de emisión (útil para débito automático de PagoMisCuentas, Link u otros y rápida recolección).'
        },
        cobro_digital_address_key: 'Dirección',
        cobro_digital_email_key: 'Email',
        cobro_digital_full_name_key: 'Nombre completo',
        cobro_digital_identifier_key: 'Identificador de cliente',
        cobro_digital_national_identifier_key: 'Nro de documento',
        consuerte: {
          box_hint_title: 'Pasos para usar Consuerte:',
          box_hint1: 'Contratar el servicio de Consuerte. ',
          box_hint2: 'Solicitar la integración con Wispro.',
          box_hint3: 'Entregar al equipo de Consuerte el API Key (Token) Asignado por Wispro.',
          form_hint:
            'Una vez cree su pasarela de pagos con Consuerte la información de la API KEY se proporcionará en la sección de detalles.'
        },
        efecty: {
          box_hint_title: 'Pasos para usar Efecty:',
          box_hint1: 'Contratar el servicio de Efecty. ',
          box_hint2: 'Solicitar la integración con Wispro.',
          box_hint3: 'Entregar al equipo de Efecty el API Key (Token) Asignado por Wispro.',
          form_hint:
            'Una vez cree su pasarela de pagos con Efecty la información de la API KEY se proporcionará en la sección de detalles.'
        },
        enabled: 'Estado',
        fast_recolection: 'Estrategia de emisión de facturas a CobroDigital',
        gateway_name: 'Pasarela',
        inform_emit_disabled: 'Informar emisión de facturas deshabilitado',
        inform_emit_enabled: 'Informar emisión de facturas habilitado',
        ipg_issue_enabled: 'Informar facturas a la pasarela de pago',
        merchant_id: 'ID Comercio',
        mi_vecino: 'Mi vecino',
        must_provide_info_to_facilito: 'Debe proporcionar los siguientes datos al equipo de Facilito',
        must_provide_info_to_pichincha: 'Debe proporcionar el ClientToken al equipo de Pichincha',
        payu: {
          account_id: 'ID de cuenta',
          merchant_id: 'ID Comercio'
        },
        pending_varification: 'Pendiente verificación por Wispro',
        pichincha_bank_debit: 'Banco Pichincha (Débito automático)',
        prisma_master: {
          account_id: 'Número establecimiento Mastercard',
          current_file_number: 'Número secuencial ascendente único por archivo'
        },
        prisma_visa_credit: {
          account_id: 'Número establecimiento VISA Crédito',
          current_file_number: 'Número secuencial ascendente único por archivo'
        },
        prisma_visa_debit: {
          account_id: 'Número establecimiento VISA Débito',
          current_file_number: 'Número secuencial ascendente único por archivo'
        },
        propagate_ipg_issue_enabled:
          'Propagar el estado de "Informar facturas a la pasarela de pago" a TODOS LOS CLIENTES ASOCIADOS.',
        propagate_ipg_issue_enabled_to_cpgs:
          'Si esta pasarela está asociada a algún cliente, su estado será modificado a Habilitado/Deshabilitado según su elección.',
        qr_enabling_process:
          'Para habilitar QR, asegúrese de tener el canal QR habilitado en SIRO y luego contacte al soporte de Wispro para completar el proceso.',
        siro: {
          account_id: 'CUIT Administrador',
          auto_confirm: 'Confirmar automáticamente las facturas en SIRO',
          cbu_holder: 'CBU de la cuenta (Banco Roela)',
          cuit_holder: 'CUIT del Titular de la cuenta',
          merchant_id: 'ID Cuenta',
          qr_enabled: 'QR habilitado',
          reference_prefix: 'Prefijo de referencia',
          required_to_use_qr: 'Necesario para usar QR',
          zip_code: 'Código Postal'
        },
        token_message: 'Este Token es requerido para el equipo de Facilito',
        verify_by_support_successfully: 'Verificación por soporte exitosa',
        verify_successfully: 'Verificación exitosa',
        vippo: {
          account_id: 'Cuenta ViPPO',
          merchant_id: 'Sucursal'
        },
        yappy: {
          account: 'Clave secreta',
          account_id: 'Clave secreta',
          api_key: 'Clave API',
          api_login: 'Sitio web',
          branch_office: 'ID comercio',
          integration_api: 'Integración API',
          integration_api_key: 'Api Key',
          merchant_id: 'ID comercio',
          payment_button: 'Botón de pago',
          seed_code: 'Código semilla'
        },
        zona_virtual: {
          form_gana_hint:
            'Para habilitar el cobro de facturas a través de <1>GANA</1>, es necesario contratar el servicio de <3>ZonaPagos</3>, el cual está integrado con <5>Wispro</5>. Al comunicarse con <7>ZonaPagos</7>, se debe solicitar la integración con <9>Wispro</9>. Una vez activado el servicio, se proporcionará un <11>ID de comercio y una contraseña</11>, que deberán ingresarse en este formulario.',
          form_gana_hint2: 'Para más información, se recomienda contactar con el equipo de soporte.'
        }
      },
      payment_gateway_transaction: {
        balance_amount: 'Balance',
        comision_amount: 'Comisión',
        date_processed: 'procesado el',
        gross_amount: 'Monto bruto',
        net_amount: 'Monto neto',
        payment: 'Pago interno',
        transaction: 'Transacción'
      },
      payment_promise: {
        created_from: 'Creada desde',
        created_from_cloud: 'Cloud',
        created_from_hola: 'Hola',
        invoicing_invoice_id: 'Factura',
        mobile: 'Móvil',
        user_id: 'Creador',
        valid_until: 'Valido hasta'
      },
      payment_receipt: {
        all: 'Todos',
        amount: 'Monto',
        client_bank_name: 'Nombre del banco',
        client_identification_number: 'Cédula',
        client_name: 'Nombre del cliente',
        client_phone_number: 'Número de teléfono',
        discarded: 'Descartado',
        error: 'Error',
        id: 'ID',
        invoice: 'Factura',
        invoice_number: 'Número de factura',
        invoicing_abstract_invoice_id: 'Factura',
        invoicing_invoice_id: 'Factura (ID)',
        invoicing_isp_id: 'ISP (ID)',
        invoicing_payment_id: 'Pago',
        pending: 'Pendiente',
        processed: 'Procesado',
        reference: 'Referencia',
        state: 'Estado',
        state_communication_error: 'Error de comunicación',
        state_discarded: 'Descartado',
        updated_at: 'Actualizado el',
        validating: 'Validando'
      },
      payment_transaction: {
        authorization_state: {
          authorized: 'Informado',
          authorizing: 'Informando',
          authorizing_error: 'Error',
          not_authorized: 'Pendiente',
          blocked: 'Bloqueada',
          blocked_tooltip: 'La transacción se enviará a autorizar cuando la factura asociada se autorice'
        },
        payment_for: 'Pago por',
        invoicing_abstract_invoice_id: 'Factura (ID)',
        invoicing_payment_id: 'Pago (ID)'
      },
      plan: {
        frecuency: 'Frecuencia',
        frecuency_1: 'Mensual',
        frecuency_2: 'Bimestral',
        frecuency_3: 'Trimestral',
        frecuency_4: 'Cuatrimestral',
        frecuency_6: 'Semestral',
        frecuency_12: 'Anual',
        auto_invoice_issuing: 'Emisión de facturas automáticas',
        automatic_state: 'Estado automático',
        charge_in_advance: 'Cobro por adelantado',
        days_for_first_due: 'Días para el 1º vencimiento',
        days_for_second_due: 'Días para el 2º vencimiento',
        days_to_alert_contract: 'Días para cambiar el estado a avisado',
        days_to_disable_contract: 'Días para cambiar el estado a deshabilitado',
        due_one_interest: 'Interés para el 1º vencimiento',
        due_two_interest: 'Interés para el 2º vencimiento',
        electronic_enabled: 'Electrónica',
        first_surcharge_product_code: 'Código de producto interés primer vencimiento',
        frequency: 'Frecuencia',
        generate_reconnection_charge: 'Generar recargo por conexión',
        installation_price: 'Precio de instalación',
        installation_product_code: 'Código de producto instalación',
        installation_tax: 'Impuesto de instalación',
        invoicing_isp_id: 'Isp',
        kind_invoice: 'Tipo de Factura',
        not_invoice_when_is_disabled: 'No generar factura cuando esta deshabilitado',
        propagate_frequency_to_contracts: 'Propagar cambio de frecuencia a los contratos asociados',
        propagate_price_to_contracts: 'Propagar cambio de precio a los contratos asociados',
        reconnection_charge_product_code: 'Código de producto cargo por reconexión',
        second_due_date_at_end_of_period: 'Segundo venc. al finalizar el periodo',
        second_surcharge_product_code: 'Código de producto interés segundo vencimiento',
        start_invoicing_date: 'Fecha inicio facturación',
        strategy_to_alert_contract: 'Cambiar estado a avisado',
        strategy_to_disable_contract: 'Cambiar estado a deshabilitado',
        tax_one: 'Impuesto',
        tax_one_id: 'Impuesto',
        taxpayer_identification_number: 'Num. de identificación tributaria',
        use_information_contract_for_invoice: 'Definir info. tributaria'
      },
      profile: {
        degraded_contract_state_table_hint:
          'Los contrato que esten degradados cuando se deshabiliten podrá navegar pero a una fracción de la velocidad del plan',
        with_interest_amount_text: '$ (Monto)',
        with_interest_percentage_text: '% (Porcentaje)',
        no_interests: 'Sin intereses',
        due_on_days: 'A {{days}} días',
        first_due_date: '1er. Vencimiento',
        second_due_date: '2do. Vencimiento',
        charge_in_advance_enabled: 'Cobrar por adelantado habilitado',
        charge_in_advance_disabled: 'Cobrar por adelantado deshabilitado',
        auto_invoice_issuing_enabled: 'Emisión automática habilitada',
        auto_invoice_issuing_disabled: 'Emisión automática deshabilitada',
        not_invoice_when_is_disabled_enabled: 'No facturar contratos deshabilitados activado',
        not_invoice_when_is_disabled_disabled: 'No facturar contratos deshabilitados desactivado',
        edit_due_date: 'Editar datos de Vencimiento',
        alert_contracts: 'Alertar',
        alert_contracts_on_due: 'Se alertaran contratos cuando la factura alcance el 1er. vencimiento',
        alert_contracts_on_days: 'Se alertaran contratos pasado {{days}} días',
        alert_contracts_on_never: 'Nunca se alertaran contratos',
        disable_contracts_on_due: 'Se deshabilitaran contratos cuando la factura alcance el 2do. vencimiento',
        disable_contracts_on_days: 'Se deshabilitaran contratos pasado {{days}} días',
        disable_contracts_on_never: 'Nunca se deshabilitaran contratos',
        disable_contracts: 'Deshabilitar',
        delinquent_contracts: 'Pasar a moroso',
        contract_strategy: {
          never_alert: 'Nunca',
          never_disable: 'Nunca',
          never_delinquent: 'Nunca',
          on_first_due_date_alert: 'Al primer vencimiento',
          on_second_due_date_disable: 'Al segundo vencimiento',
          set_days_alert: 'Pasado {{days}} días del 1er Vencimiento',
          set_days_disable: 'Pasado {{days}} días del 2do Vencimiento',
          set_days_delinquent: 'Pasado {{days}} días del 2do Vencimiento'
        },
        table_headers: {
          when_generate: 'Como Interpretar la fecha de generación de la factura',
          contract_strategy: 'Estrategia de Contratos',
          configuration: {
            title: 'Revisa si estas funciones están <enabledIcon/>habilitadas o <disabledIcon/>deshabilitadas',
            charge_in_advance: {
              enabled_item:
                '<wrapper><enabledIcon/>Se factura al inicio del periodo. Los vencimientos parten desde el primer día del ciclo.</wrapper>',
              disabled_item:
                '<wrapper><disabledIcon/>Se factura a mes vencido. Los vencimientos se definen al final del período o en los días previos configurados.</wrapper>'
            },
            auto_invoice_issuing: {
              enabled_item:
                '<wrapper><enabledIcon/>Al generarse la factura, el sistema la emite de forma automática.</wrapper>',
              disabled_item: '<wrapper><disabledIcon/>La factura debe emitirse manualmente.</wrapper>'
            },
            not_invoice_when_is_disabled: {
              enabled_item:
                '<wrapper><enabledIcon/>Si un contrato está inactivo, no se generará factura para el nuevo periodo.</wrapper>',
              disabled_item: '<wrapper><disabledIcon/>Los contratos inactivos también generan factura.</wrapper>'
            }
          }
        },
        charge_in_advance: 'Cobrar por adelantado',
        auto_invoice_issuing: 'Emisión automática',
        days_before_end_period: 'Días antes del vencimiento',
        days_for_first_due: 'Días para el primer vencimiento',
        days_for_second_due: 'Días para el segundo vencimiento',
        days_for_second_due_indicator: 'del inicio del periodo',
        days_to_alert_contract: 'Días para alertar al contrato',
        days_to_disable_contract: 'Días para deshabilitar al contrato',
        days_to_delinquent_contract: 'Días para marcar el contrato moroso',
        default: 'Por defecto',
        default_profile_description: 'Se Facturara con este perfil de facturacion',
        degraded_state_when_disabled: 'Degradar el servicio',
        first_due_date_enabled: 'Habilitar primer vencimiento',
        invoice_generation_title: 'Generación de Factura',
        beginning_of_period: 'del inicio del periodo',
        end_of_period: 'del final del periodo',
        days_before_end: 'Seleccionar días previos al final del periodo',
        days_before_end_indicator: 'A {{days}} días antes del fin del periodo',
        current_period: 'Periodo actual',
        next_period: 'Próximo periodo',
        never: 'Nunca',
        on_first_due_date: '1er. Vencimiento',
        on_second_due_date: '2do. Vencimiento',
        set_days: 'Definir días',
        form_hints: {
          default: 'Aparecerá por defecto en el formulario de creación de contrato',
          default_profile: 'El perfil por defecto es: <strong>{{profile}}</profile>',
          charge_in_advanced_enabled:
            '<b>Habilitado</b> Se factura al inicio del periodo. Los vencimientos se establecen a partir del primer día del periodo de facturación del cliente.',
          charge_in_advanced_disabled:
            '<b>Deshabilitado:</b> Se factura a mes vencido. Los vencimientos se establecen a partir del último día del periodo de facturación del cliente.',
          invoice_generation_subtitle:
            'Al facturar a mes vencido, el sistema puede generar la factura en las siguientes fechas:',
          generation_quote:
            '  <b>Nota:</b> La duración de los periodos depende de la fecha de inicio de facturación de cada cliente.',
          auto_invoice_issuing: 'Una vez generada la factura por el sistema, se emitirá automáticamente',
          not_invoice_when_is_disabled: 'Si el contrato está inactivo, no se generará la factura del nuevo período.',
          surcharges_description:
            '         <div><b>Monto de Tolerancia</b><p>Permite que las facturas cuando lleguen a primer o segundo vencimiento, no podrán cambiar el estado del contrato a <i>alertado</i>, <i>degradado</i> o <i>deshabilitado</i>, si el cliente tiene habilitado el estado automático y el saldo de la factura es menor o igual al monto de tolerancia.</p></div>',
          surcharges_quote: '<span><b>Nota:</b> El monto 0 deshabilita esta funcionalidad.</span>',
          strategy_to_invoice_surcharges:
            '<div><SCBlock><b>Próximo Periodo:</b> Los recargos generados por los vencimientos, se incluirán en la próxima factura del contrato. Tenga en cuenta que los intereses son acumulables, y se incluirá un item en la factura por cada recargo a cobrar.</SCBlock><SCBlock><b>Periodo Actual:</b> Los recargos serán facturados en el periodo actual, con una factura por cada vencimiento.</SCBlock></div>',
          days_for_first_due:
            'Días que deben pasar hasta el primer vencimiento (según si el cobro es adelantado o no).',
          interests:
            '<div>Si el <b>interés del 1º vencimiento es como Monto</b> las facturas a generar tendrán el valor ingresado.</div><div>Si el <b>interés del 1º vencimiento es como Porcentaje</b> Los valores deberán ser entre 0 (sin interés) hasta 100.</div>',
          interest_first_due_date_as_mount_label:
            '<div><b>Habilitado:</b> El interés se define como un monto fijo.</div><div><b>Deshabilitado:</b> El interés se calcula como un porcentaje del total de la factura.</div>',
          second_due_date_at_end_of_period:
            'El 2º vencimiento se establecerá siempre al final del periodo de cada factura que se genere.',
          days_for_second_due:
            'Días que deben pasar hasta el segundo vencimiento (según si el cobro es adelantado o no).',
          interests_section:
            '<div>Si el <b>interés del 2º vencimiento es como Monto</b> las facturas a generar tendrán el valor ingresado.</div><div>Si el <b>interés del 2º vencimiento es como porcentaje</b> Los valores deberán ser entre 0 (sin interés) hasta 100.</div><div><b>NOTA:</b> Los intereses son acumulables.</div>',
          interest_second_due_date_as_mount:
            '<div><b>Habilitado:</b> El interés se define como un monto fijo.</div><div><b>Deshabilitado:</b> El interés se calcula como un porcentaje del total de la factura.</div>',
          surcharges: 'Solo se generará el recargo por conexión si se supera el 2º vencimiento.',
          reconnection_charge: 'Monto bruto del recargo por conexión',
          interest_as_amount_hint:
            '<div><b>Habilitado:</b> El interés se define como un monto fijo..</div><div><b>Deshabilitado:</b> El interés se calcula como un porcentaje del total de la factura.</div>',
          strategy_to_alert_contracts:
            "<div><b>Nunca:</b> Utilizar en caso de que nunca se quierá que el sistema cambie el estado de los contratos a 'alertado'.</div><div><b>1º vencimiento:</b> En el momento que alguna factura alcance su fecha de 1º vencimiento, el sitema cambiará el estado del contrato en 'alertado'.</div><div><b>Definir días:</b> Establece cuantos días después de haberse alcanzado el 1º vencimiento el contrato se alertará.</div>",
          strategy_to_disable_contracts:
            "<div><b>Nunca:</b> Utilizar en caso de que nunca se quiera que el sistema deshabilite contratos.</div><div><b>2do. vencimiento:</b> En el momento que alguna factura alcance su fecha de 2º vencimiento, el sistema cambiará el estado del contrato a 'deshabilitado'.</div><div><b>Definir días:</b> Establece cuantos días después de haberse alcanzado el 2º vencimiento, el sistema cambiará el estado del contrato a 'deshabilitado'.</div>",
          strategy_to_delinquent_contracts:
            "<div><b>Nunca:</b> Utilizar en caso de que nunca se quiera que el sistema marque como moroso los contratos.</div><div><b>Definir días:</b> Establece cuantos días después de haberse alcanzado el 2º vencimiento, el sistema cambiará el contrato a 'moroso'.</div>",
          days_to_disable_contract:
            'Dias que deben transcurrir para deshabilitar el contrato una vez alcanzado el 2º vencimiento',
          days_to_delinquent_contract:
            'Dias que deben transcurrir para marcar el contrato moroso una vez alcanzado el 2º vencimiento',
          degraded_state_when_disabled: 'El contrato podrá navegar pero a una fracción de la velocidad del plan'
        },
        strategy_to_alert_contracts: 'Estrategia para alertar Contratos',
        strategy_to_disable_contracts: 'Estrategia para deshabilitar Contratos',
        strategy_to_delinquent_contracts: 'Estrategia para marcar Contratos morosos',
        generate_reconnection_charge: 'Generar recargo por conexión',
        interest_first_due_date: 'Interés del primer vencimiento',
        interest_first_due_date_as_mount: 'Monto fijo para el interés (1º vencimiento)',
        interest_first_due_date_as_mount_label: 'Habilitar interés como monto fijo',
        interest_second_due_date: 'Interés del segundo vencimiento',
        interest_second_due_date_as_mount: 'Monto fijo para el interés (2º vencimiento)',
        invoicing_tax_reconnection_charge_id: 'Impuesto del recargo por conexión',
        not_invoice_when_is_disabled: 'No facturar contratos deshabilitados',
        second_due_date_at_end_of_period: '2º vencimiento al final de periodo',
        second_due_date_enabled: 'Habilitar segundo vencimiento',
        strategy_to_alert_contract: 'Estrategia para alertar al contrato',
        strategy_to_alert_contract_never: 'Nunca',
        strategy_to_alert_contract_set_days: 'Definir días',
        strategy_to_alert_contract_on_first_due_date: 'Al primer vencimiento',
        strategy_to_alert_contract_on_second_due_date: 'Al segundo vencimiento',
        strategy_to_disable_contract: 'Estrategia para deshabilitar al contrato',
        strategy_to_disable_contract_never: 'Nunca',
        strategy_to_disable_contract_set_days: 'Definir días',
        strategy_to_disable_contract_on_first_due_date: 'Al primer vencimiento',
        strategy_to_disable_contract_on_second_due_date: 'Al segundo vencimiento',
        strategy_to_delinquent_contract: 'Estrategia para marcar moroso al contrato',
        strategy_to_delinquent_contract_never: 'Nunca',
        strategy_to_delinquent_contract_set_days: 'Definir días',
        strategy_to_delinquent_contract_on_first_due_date: 'Al primer vencimiento',
        strategy_to_delinquent_contract_on_second_due_date: 'Al segundo vencimiento',
        strategy_to_invoice_surcharges: 'Estrategia para facturar recargos',
        strategy_to_invoice_surcharges_next_period: 'Próximo periodo',
        strategy_to_invoice_surcharges_current_period: 'Periodo actual',
        tax_reconnection_charge: 'Impuesto del recargo por conexión',
        tolerance_amount: 'Monto de tolerancia',
        days_to_disable_contract_label: 'Días para deshabilitar',
        days_to_delinquent_contract_label: 'Días para marcar moroso',
        tour: {
          count_info_description:
            'Este contador indica cuántos registros se muestran. Si aplicas una búsqueda o filtros verás el total filtrado sobre el total general, y con el botón de borrar podrás limpiar la búsqueda y volver al listado completo.',
          count_info_title: 'Registros mostrados',
          create_profile_description:
            'Con este botón puedes crear un nuevo perfil de facturación. Al hacer clic se abrirá un formulario donde ingresarás los datos necesarios y, al guardarlo, el perfil quedará disponible en la lista.',
          create_profile_title: 'Crear perfil de facturación',
          form_basic_tab_description_left:
            'Completa los datos principales del perfil, como el nombre, si el cobro será por adelantado y las reglas de generación de facturas según el período de facturación.',
          form_basic_tab_description_right:
            'En esta sección puedes configurar la emisión automática de facturas, definir si se facturarán contratos deshabilitados y establecer las reglas de recargos con su respectivo monto de tolerancia.',
          form_basic_tab_title_left: 'Pestaña Básica #1',
          form_basic_tab_title_right: 'Pestaña Básica #2',
          form_container_description:
            'Este es el formulario para crear un nuevo perfil de facturación. Está organizado en pestañas que iremos recorriendo paso a paso para completar todos los datos necesarios.',
          form_container_title: 'Formulario',
          form_due_tab_first_description:
            'Aquí defines los días hasta el primer vencimiento y, si lo deseas, puedes aplicar intereses ya sea como un monto fijo o como un porcentaje sobre el valor de la factura.',
          form_due_tab_first_title: 'Primer vencimiento',
          form_due_tab_second_title: 'Segundo vencimiento',
          form_due_tab_second_title_description:
            'Configura los días hasta el segundo vencimiento, define si se aplicarán intereses acumulativos como monto o porcentaje y, si lo necesitas, establece un cargo de reconexión que se generará al superarse este vencimiento.',
          form_strategy_tab_alert_description:
            'Aquí defines cuándo un contrato pasará al estado de alertado. Puedes configurarlo para que ocurra en el primer vencimiento o después de cierto número de días, según lo necesites.',
          form_strategy_tab_alert_title: 'Para alertar contratos',
          form_strategy_tab_disable_description:
            'Configura el momento en que los contratos se deshabilitarán, ya sea al segundo vencimiento o tras un plazo definido. También puedes activar la degradación del servicio para que el cliente navegue con velocidad reducida en lugar de quedar totalmente inactivo.',
          form_strategy_tab_disable_title: 'Para deshabilitar contratos',
          table_col_actions_edit_description:
            'Modifica cualquier detalle de este perfil y ajusta configuraciones para que todo se adapte a tus necesidades.',
          table_col_actions_edit_title: 'Editar Perfil',
          table_col_contract_strategy_title: 'Estrategia para Contratos',
          table_col_contract_strategy_description:
            'Configura cómo gestionar tus contratos: recibe alertas cerca del primer vencimiento y controla los contratos deshabilitados con avisos basados en el segundo vencimiento, todo desde un mismo lugar.',
          table_col_contract_info_description:
            'Visualiza cuántos contratos están vinculados a este perfil para tener un control rápido de tu gestión.',
          table_col_contract_info_title: 'Contratos Asignados',
          table_col_first_due_description:
            'Consulta cuándo vence este periodo y el interés aplicable. También puedes editarlo si necesitas hacer ajustes rápidos.',
          table_col_first_due_title: 'Primer Vencimiento',
          table_col_icons_description:
            'visualiza de un vistazo si la autoemisión de facturas y la generación de contratos deshabilitados están activas. ¡Así sabrás qué funciones están listas para usar!',
          table_col_icons_title: 'Configuración de Facturación',
          table_col_indicators_description:
            'Define los días antes del vencimiento y el monto de tolerancia. Personaliza tus alertas y recordatorios para mantener todo bajo control.',
          table_col_indicators_title: 'Ajustes de Vencimiento',
          table_col_name_description:
            'Aquí podrás ver los datos principales del perfil de facturación: el identificador, su nombre, las fechas de creación y actualización, además de un indicador que señala si el perfil está marcado como predeterminado.',
          table_col_name_title: 'Información del perfil',
          table_col_second_due_description:
            'Observa la fecha y el interés del segundo vencimiento. Modifícalo fácilmente si cambian tus condiciones.',
          table_col_second_due_title: 'Segundo Vencimiento',
          form_strategy_tab_delinquent_title: 'Contratos como morosos',
          form_strategy_tab_delinquent_description:
            'Configura cuándo un contrato se marcará como moroso, ya sea nunca o después de un período definido tras el segundo vencimiento.'
        },
        when_generate: 'Cuando generar la factura',
        when_generate_beginning_of_period: 'Al inicio del periodo',
        when_generate_end_of_period: 'Al final del periodo',
        when_generate_days_before_end: 'Días antes del final del periodo'
      },
      recurring_item: {
        amount: 'Monto',
        count_of_items: 'Cantidad de items',
        description: 'Descripción',
        discount_percentage: 'Descuento (%)',
        invoicing_kind_id: 'Plantilla Item Recurrente',
        invoicing_tax_one_id: 'Impuesto',
        kind: 'Item',
        lapse: 'Periodos',
        product_code: 'Código de producto',
        quantity: 'Cantidad',
        tax_one: 'Impuesto',
        tax_one_id: 'Impuesto'
      },
      service_invoice: {
        amount: 'Monto total',
        auto_invoice_issuing: 'Auto emitir la factura',
        charge_installation: 'Cobrar instalación?',
        from_day: 'Desde',
        installation_amount: 'Monto de instalación',
        to_day: 'Hasta'
      },
      tax: {
        code: 'Código',
        rate: 'Porcentaje',
        kind_iva: 'IVA',
        kind_colombia_ico: 'ICO (Colombia)',
        kind_colombia_ica: 'ICA (Colombia)',
        kind_colombia_contrib: 'Contribución (Colombia)',
        kind_colombia_ret_iva: 'Retención IVA (Colombia)',
        kind_colombia_ret_ica: 'Retención ICA (Colombia)',
        kind_mexico_ieps: 'IEPS (México)',
        kind_costa_rica_911: '911 (Costa Rica)',
        kind_costa_rica_cruz_roja: 'Cruz Roja (Costa Rica)',
        kind_ecuador_ice: 'ICE (Ecuador)',
        kind_panama_itbms: 'ITBMS (Panamá)',
        kind_panama_sume: 'SUME (Panamá)',
        kind_peru_igv: 'IGV (Perú)',
        tour: {
          help_title: 'Ayuda',
          help_description: 'Desde aquí puedes consultar documentación relacionada con impuestos.',
          search_title: 'Búsqueda rápida',
          search_description: 'Busca impuestos por nombre o código sin necesidad de abrir los filtros avanzados.',
          filters_title: 'Filtros',
          filters_description: 'Usa estos filtros para buscar impuestos por nombre, código, tipo o tasa.',
          count_title: 'Registros mostrados',
          count_description:
            'Este contador indica cuántos impuestos estás viendo según los filtros aplicados. Con el botón de borrar puedes limpiar la búsqueda y volver al listado completo.',
          create_title: 'Crear impuesto',
          create_description: 'Abre el formulario para registrar un nuevo impuesto.',
          form_title: 'Formulario de impuesto',
          form_description: 'Completa los datos del impuesto antes de guardar.',
          name_input_title: 'Nombre',
          name_input_description: 'Nombre del impuesto. Es el que identifica cada fila en la tabla.',
          code_input_title: 'Código',
          code_input_description: 'Código fiscal opcional asociado al impuesto. Si lo dejas vacío no se guarda ningún valor.',
          kind_input_title: 'Tipo de impuesto',
          kind_input_description: 'Las opciones vienen del backend según el país de tu ISP.',
          rate_input_title: 'Tasa',
          rate_input_description:
            'Indica la tasa del impuesto. Algunos impuestos no permiten cambiar la tasa si ya están asociados a clientes.',
          form_buttons_title: 'Acciones del formulario',
          form_buttons_description:
            'Cancela sin guardar o confirma los cambios. Al editar un impuesto también verás el botón Eliminar.',
          sequential_id_column_title: 'Identificador',
          sequential_id_column_description: 'Número secuencial que identifica al impuesto.',
          name_column_title: 'Nombre',
          name_column_description: 'Nombre visible del impuesto.',
          kind_column_title: 'Tipo',
          kind_column_description: 'Tipo de impuesto según la configuración fiscal del país.',
          rate_column_title: 'Tasa',
          rate_column_description: 'Porcentaje o tasa aplicada por el impuesto.',
          code_column_title: 'Código',
          code_column_description: 'Código fiscal opcional asociado al impuesto.',
          audit_action_title: 'Auditoría',
          audit_action_description: 'Consulta el historial de cambios de este impuesto.',
          edit_action_title: 'Editar',
          edit_action_description:
            'Modifica los datos de este impuesto. Si no tienes permisos, este botón aparecerá deshabilitado.'
        }
      },
      transaction: {
        abstract_invoice: 'Factura',
        current_account: 'Cuenta corriente',
        invoicing_abstract_invoice_id: 'Factura',
        invoicing_current_account_id: 'Cuenta corriente',
        invoicing_payment_id: 'Pago (ID)',
        payment: 'Pago',
        transaction_kind: 'Forma de pago',
        transaction_kind_id: 'Tipo'
      },
      transaction_kind: {
        name_disabled_by_relations_hint:
          'No se puede modificar el nombre porque esta forma de pago tiene pagos o transacciones asociadas.',
        api_payment: 'Pago API',
        bank_transfer: 'Transferencia bancaria',
        cardnet_payment: 'Cardnet',
        cash: 'Efectivo',
        check: 'Cheque',
        cobro_digital_payment: 'CobroDigital',
        combo_pay_payment: 'ComboPay',
        credit_card: 'Tarjeta de crédito',
        credit_note: 'Nota de Crédito',
        cuenta_digital_payment: 'CuentaDigital',
        current_account: 'Cuenta Corriente',
        debit_card: 'Tarjeta de débito',
        efecty_payment: 'Efecty',
        electronic_transfer: 'Transferencia Electrónica',
        enabled_for_collector: 'Habilitada para Recaudador',
        facilito_payment: 'Facilito',
        gana_payment: 'Gana',
        invoice: 'Factura',
        mercado_pago_payment: 'MercadoPago',
        one_pay_payment: 'OnePay',
        online_payment: 'Pago Online',
        pagoralia_payment: 'Pagoralia',
        payment_deleted: 'Pago Eliminado',
        payu_payment: 'PayU',
        pichincha_payment: 'Pichincha',
        prisma: 'Prisma',
        refund: 'Reembolso',
        service_card: 'Tarjeta de Servicio',
        siro_payment: 'Siro',
        unidentified: 'No identificado',
        vippo_payment: 'ViPPO',
        wispro_migration: 'Wispro Migration',
        wompi_payment: 'Wompi',
        yappy_payment: 'Yappy',
        zona_virtual_payment: 'Zona Virtual',
        tour: {
          help_title: 'Ayuda',
          help_description: 'Accede a documentación relacionada con formas de pago.',
          search_title: 'Búsqueda rápida',
          search_description: 'Busca formas de pago por nombre usando sugerencias.',
          filters_title: 'Filtros',
          filters_description: 'Filtra por nombre, tipo, habilitada o habilitada para recaudador.',
          count_title: 'Registros mostrados',
          count_description:
            'Indica cuántas formas de pago estás viendo según la búsqueda o filtros aplicados. Con el botón de borrar podrás limpiar la búsqueda y volver al listado completo.',
          create_title: 'Crear forma de pago',
          create_description: 'Abre el formulario para crear una nueva forma de pago administrable.',
          table_title: 'Tabla de formas de pago',
          table_description: 'Lista las formas de pago editables disponibles para administración.',
          table_col_sequential_id_title: 'ID',
          table_col_sequential_id_description: 'Identificador secuencial de la forma de pago.',
          table_col_name_title: 'Nombre',
          table_col_name_description: 'Nombre de la forma de pago tal como se muestra en toda la plataforma.',
          kind_title: 'Tipo',
          kind_description: 'Indica si la forma de pago es de crédito o débito.',
          enabled_for_collector_title: 'Habilitada para recaudador',
          enabled_for_collector_description:
            'Define si esta forma de pago está disponible para usuarios con rol recaudador.',
          enabled_title: 'Habilitada',
          enabled_description: 'Permite activar o desactivar la forma de pago.',
          table_col_updated_at_title: 'Última actualización',
          table_col_updated_at_description: 'Fecha de la última modificación de este registro.',
          actions_title: 'Acciones',
          actions_description: 'Desde aquí puedes auditar o editar una forma de pago, según tus permisos.',
          table_action_edit_title: 'Editar',
          table_action_edit_description: 'Abre el formulario para modificar los datos permitidos de este registro.',
          table_action_audit_title: 'Auditoría',
          table_action_audit_description: 'Consulta el historial de cambios de esta forma de pago.',
          form_title: 'Formulario de forma de pago',
          form_description: 'Completa o actualiza los datos permitidos de la forma de pago.',
          name_title: 'Nombre',
          name_description:
            'Nombre visible de la forma de pago. Puede bloquearse si ya tiene pagos o transacciones asociadas.',
          form_enabled_title: 'Habilitada',
          form_enabled_description: 'Activa o desactiva esta forma de pago.',
          form_enabled_for_collector_title: 'Habilitada para recaudador',
          form_enabled_for_collector_description: 'Define si está disponible para usuarios con rol recaudador.',
          form_cancel_title: 'Cancelar',
          form_cancel_description: 'Cierra el formulario sin guardar cambios.',
          form_submit_title: 'Guardar',
          form_submit_description: 'Guarda los cambios y actualiza el listado.'
        }
      },
      vippo_payment_receipt: {
        invoicing_payment_receipt_id: 'Recibo de pago',
        invoicing_payment_gateway_transaction_id: 'Transacción de pasarela de pago',
        payment_result: 'Resultado del pago'
      }
    },
    iproute: {
      conflict_ips: 'Ips fuera del rango',
      dhcp_enabled: 'Habilitar DHCP',
      dhcp_gateway: 'Puerta de enlace asignar por DHCP',
      dhcp_ranges: 'Rangos de Dhcp',
      dst_address: 'Dirección destino',
      gateway: 'Puerta de enlace',
      interface: 'Interface',
      lease_time: 'Tiempo de lease'
    },
    isp: {
      country_name: 'País',
      gps_location: 'Ubicación',
      invoice_push_notification: 'Notificación push de factura',

      mobilephone_number: 'Telefono Móvil',
      name: 'Nombre del ISP',
      payment_push_notification: 'Notificación push de pago',
      telephone_number: 'Teléfono fijo'
    },
    kind_feedback: {
      kind: 'Tipo de feedback'
    },
    kind_person: {
      mexico_natural: 'Persona Física',
      mexico_juridic: 'Persona Moral'
    },
    nas: {
      create_new_nas: 'Crear nueva NAS',
      drag_here: 'Arrastre los Boxes aquí',
      available_agents: 'Boxes Disponibles',
      selected_agents: 'Boxes Seleccionados',
      shortname: 'Nombre corto',
      cloud_interface_id: 'Interfaz',
      cloud_access_server_id: 'Concentrador de acceso'
    },
    nap: {
      contracts_count: 'Cantidad de contratos',
      create_new_nap: 'Crear nueva NAP',
      fbp: 'Puerto',
      feasibility_distance: 'Distancia de factibilidad (en metros)',
      inventory_article_id: 'Artículo de inventario',
      massive_update: 'Actualización masiva',
      nap_port: {
        ports_with_contracts: 'con contrato',
        ports_without_contracts: 'sin contrato',
        manage_ports: 'Gestionar Puertos',
        state: {
          free: {
            one: 'Libre',
            other: 'Libres'
          },
          filled: {
            one: 'Ocupado',
            other: 'Ocupados'
          },
          available: {
            one: 'Disponible',
            other: 'Disponibles'
          },
          filled_with_contract: {
            one: 'Ocupado con contrato',
            other: 'Ocupados con contrato'
          },
          filled_without_contract: {
            one: 'Ocupado sin contrato',
            other: 'Ocupados sin contrato'
          },
          broken: {
            one: 'Averiado',
            other: 'Averiados'
          }
        }
      },
      seals: {
        state: {
          with_contract: 'con contrato asociado',
          without_contract: 'sin contrato asociado'
        }
      },
      placeholder_basic_search: 'Nombre, FBP, Olt',
      power_limit: 'Potencia límite',
      select_nap: 'Debe seleccionar al menos una NAP'
    },
    node: {
      contracts_count: 'Contratos',
      gps_point: 'Punto Gps'
    },
    node_device: {
      availability: 'Disponibilidad',
      contracts_count: 'Contratos'
    },
    notification_mail: {
      default_body: 'Cuerpo por defecto',
      default_subject: 'Asunto por defecto',
      email: 'Responder a',
      first_image: 'Primera imagen',
      lapse: 'Lapso (número)',
      online_changed: 'Cambio de estado',
      second_image: 'Segunda imagen',
      unit: 'Unidad de tiempo'
    },
    notification_web: {
      auto_redirect_interval: 'Intervalo de auto-redirección',
      contract_notifications: 'Contratos',
      default_body: 'Cuerpo por defecto',
      from_at: 'Desde',
      lapse: 'Lapso',
      lapse_time: 'Lapso',
      unit: 'Unidad'
    },
    notifications: {
      auto_redirect_interval: 'Intervalo de auto-redirección',
      contracts_seens: 'Contratos/Vistos',
      email: 'Responder a',
      from_at: 'Desde',
      kind_subject: 'Tipo - Asunto',
      lapse_time: 'Lapso',
      times: 'Cantidad',
      unit: 'Unidad'
    },
    ont: {
      admin_status: 'Admin status',
      admin_state: 'Admin state',
      aging: 'Aging',
      auth_flag: 'Auth flag',
      auth_mode: 'Auth mode',
      alarm_policy_profile: 'Alarm policy profile',
      alarm_profile_id: 'Alarm profile ID',
      alive_time: 'Alive time',
      attenuation: 'Atenuación',
      auth_info: 'Autenticación (Modo)',
      auth_info_form: 'Autenticación ({{auth_mode}})',
      auth_info_fuse: 'Autenticación',
      auth_info_fuse_placeholder: 'Número de Serie/LOID/PWD',
      authentic_mode: 'Autenticación (Modo)',
      authentication_mode: 'Authentication mode',
      authentic_type: 'Autenticación (Tipo)',
      authorized: 'Autorizada',
      authorized_onts: 'ONUs autorizadas ',
      authorized_onts_linked: 'ONUs autorizadas con Contrato',
      authorized_onts_not_linked: 'ONUs autorizadas no vinculadas',
      auto_replace: 'Auto replace',
      basic_info: 'Información Básica',
      battery_backup: 'Battery backup',
      battery_monitor: 'Battery monitor',
      binding_lan: 'Binding LAN',
      bindinglan: 'Binding LAN',
      binding_ssid: 'Binding SSID',
      bindingssid: 'Binding SSID',
      capa2: 'Información Capa 2',
      bridge_mode: 'Bridge mode',
      bridge_port_binding: 'Bridge port binding',
      board: 'Board',
      cant_get_info: 'No se pudo obtener la información de la ONU',
      capability_info: 'Capacidad de la ONU',
      catv: 'CATV',
      catv_info_empty: 'No se pudo obtener información de CATV o no está soportado por la ONU',
      catv_rx_optical_power: 'CATV RX Power',
      catv_rx_power_alarm_threshold: 'CATV RX Power alarm threshold',
      catv_port_off: 'Apagado',
      catv_port_on: 'Encendido',
      catv_ports_info: 'Información puertos CATV',
      ces_uni_number: 'CES UNI number',
      chip_info: 'Chip info',
      config_method: 'Config method',
      config_state: 'Config state',
      config_status: 'Config status',
      configure_channel: 'Configure channel',
      connect_mode: 'Connect Mode',
      connect_type: 'Connect type',
      connection_status: 'Connection status',
      connection_type: 'Connection type',
      contract_id_eq: 'Contrato',
      control_flag: 'Control flag',
      cos: 'cos',
      cpu_occupation: 'CPU occupation',
      ctc_spc_version: 'CTC spc version',
      cuc_spc_version: 'CUC spc version',
      current_gateway: 'Current gateway',
      current_ip_address: 'Current IP address',
      current_mask: 'Current mask',
      current_primary_dns: 'Current primary DNS',
      current_second_dns: 'Current second DNS',
      date_code: 'Date code',
      dba_mode: 'DBA mode',
      dba_type: 'DBA type',
      default_gateway: 'Default gateway',
      dhcp_enable: 'DHCP Habilitado',
      disable: 'Deshabilitado',
      distance: 'Distancia',
      distance_m: 'Distancia (m)',
      domain_name: 'Domain name',
      down_priority_queue_number: 'Down priority queue number',
      downstream: 'Downstream',
      downstream_pq_color_policy: 'Downstream PQ color policy',
      ds_lite_mode: 'DS lite mode',
      ds_lite_peer_address: 'DS lite peer address',
      dsp_mode: 'DSP mode',
      enable: 'Habilitado',
      encapsulation_type: 'Encapsulation type',
      equipment_id: 'Equipment ID',
      eth: 'ETH',
      ethernet_uni_number: 'Ethernet UNI number',
      exchange: 'Exchange',
      fe: 'Fast Ethernet',
      fec: 'FEC',
      fec_actual_mode: 'FEC actual mode',
      fec_upstream: 'FEC upstream',
      fec_upstream_switch: 'FEC upstream switch',
      frame: 'Frame',
      frame_slot_port: 'Frame/Slot/Port',
      flow_para: 'Flow param',
      flow_type: 'Flow type',
      fs: 'Frame/Slot',
      gateway: 'Puerta de enlace',
      ge: 'Gibabit Ethernet',
      gem_port_number: 'GEM port number',
      gemport_id: 'GEM port ID',
      hardware_version: 'Versión del Hardware',
      host_id: 'Host ID',
      host_name: 'Host name',
      identify: 'Identify',
      iface_name: 'Nombre de la interfaz',
      index: 'Index',
      inner_pri: 'Inner priority',
      inner_vlan: 'Inner VLAN',
      interface_types: 'Información de los puertos',
      igmp_proxy: 'IGMP proxy',
      interoperability_mode: 'Interoperability mode',
      i_pv6_host_number: 'IPV6 host number',
      ip_host_number: 'IP host number',
      ip_mode: 'Modo',
      iphost: 'IPHOST',
      ip_addres: 'IP address',
      i_pv4_address: 'IPV4 address',
      i_pv4_access_type: 'IPV4 access type',
      i_pv4_connection_status: 'IPV4 connection status',
      i_pv4_switch: 'IPV4 switch',
      i_pv6_address: 'IPV6 address',
      i_pv6_address_access_mode: 'IPV6 address access mode',
      i_pv6_address_preferred_time: 'IPV6 address preferred time',
      i_pv6_address_status: 'IPV6 address status',
      i_pv6_address_valid_time: 'IPV6 address valid time',
      i_pv6_connection_status: 'IPV6 connection status',
      i_pv6_switch: 'IPV6 switch',
      ipv4_address: 'IPV4 address',
      ipv4_gateway: 'IPV4 gateway',
      ipv4_mask: 'IPV4 mask',
      ipv4_primary_dns: 'IPV4 primary DNS',
      ipv4_secondary_dns: 'IPV4 secondary DNS',
      ipv6_host_number: 'IPV6 host number',
      isolation_state: 'Isolation state',
      l2_encap_type: 'L2 encapsulation type',
      laser_bias_current: 'Laser bias current',
      last_dereg_reason: 'Last deregistered reason',
      last_dereg_time: 'Last deregistered time',
      last_deregist_reason: 'Last deregistered reason',
      last_distance: 'Última distancia obtenida',
      last_down_cause: 'Last down cause',
      last_down_time: 'Last down time',
      last_dying_gasp: 'Last dying gasp',
      last_dying_gasp_time: 'Last dying gasp time',
      last_offline_time: 'Last offline time',
      last_online_time: 'Last online time',
      last_reg_time: 'Last registered time',
      last_up_time: 'Last up time',
      line_profile: 'Line profile',
      line_profile_id: 'Line profile ID',
      line_profile_name: 'Line profile name',
      llid: 'LLID',
      loid: 'Loid',
      loid_pwd: 'Loid password',
      mac_address: 'Dirección MAC',
      mac_address_i_cont: 'Dirección MAC',
      mac_aging_time: 'MAC aging time',
      mac_learning_function_switch: 'MAC learning function switch',
      mac_learning_switch: 'MAC learning switch',
      main_software_is_active: 'Main software is active',
      main_software_is_commit: 'Main software is commit',
      main_software_version: 'Main software version',
      manage_priority: 'Manage priority',
      manage_vlan: 'Manage VLAN',
      management_mode: 'Management mode',
      master_dns: 'DNS 1',
      mask: 'Mask',
      match_state: 'Match state',
      mapping_mode: 'Mapping mode',
      memory_occupation: 'Memory occupation',
      moca: 'MoCA',
      module_type: 'Module type',
      module_sub_type: 'Module sub type',
      mtu: 'MTU',
      multillid: 'Multi LLID',
      multicast_encryption: 'Multicast encryption',
      multicast_forward_mode: 'Multicast forward mode',
      multicast_forward_vlan: 'Multicast forward vlan',
      multicast_mode: 'Multicast mode',
      muticast_vlan: 'Muticast Vlan',
      nat_enable: 'NAT?',
      native_vlan_option: 'Native vlan option',
      netmask: 'Mascara de red',
      number_of_catv_uni_ports: 'CATV UNI ports number',
      number_of_catv_ports: 'CATV ports number',
      number_of_eth_ports: 'ETH ports number',
      number_of_fe_ports: 'FE ports number',
      number_of_ge_ports: 'GE ports number',
      number_of_gem_ports: 'GEM ports number',
      number_of_iphost: 'IPHOSTs number',
      number_of_pots_ports: 'POTS ports number',
      number_of_tconts: 'T-CONTs number',
      number_of_t_con_ts: 'T-CONTs number',
      number_of_uplink_pon_ports: 'Uplink PON ports number',
      number_of_veip: 'VEIPs number',
      number_of_veip_ports: 'VEIP ports number',
      number_of_xge_ports: 'XGE ports number',
      number_of_wlan_ports: 'WLAN ports number',
      onts_count: 'Mostrando {{count}} ONUs',
      omcc_encrypt: 'OMCC encrypt',
      omcc_encrypt_switch: 'OMCC encrypt switch',
      omcc_version: 'OMCC version',
      omci_bw_profile: 'OMCI BW profile',
      online: 'Conectada',
      offline: 'Desconectada',
      offline_reason: 'Offline reason',
      on_line_time: 'Online time',
      online_time: 'Online time',
      operator_id: 'Operator ID',
      option60: 'Option 60',
      ont_battery_state: 'ONU battery state',
      ont_id: 'ONU ID',
      ont_ip_address_mask: 'ONU IP address mask',
      ont_product_description: 'ONU product description',
      ont_transparent_function_switch: 'ONU transparent function switch',
      ont_type: 'Tipo ONU',
      ont_version: 'ONU version',
      onts_status: 'Estado de ONUs',
      onu_id: 'ID ONU',
      onu_identifier: 'ID ONU',
      onu_info: 'Información de la ONU',
      onu_model: 'Modelo de la ONU',
      onu_nni_port_id: 'ONU NNI port ID',
      onu_profile: 'Perfil ONU',
      onu_status: 'Estado de la ONU',
      onu_type: 'Tipo ONU',
      onus_by_pon_port: 'Cantidad de ONUs por puerto',
      onus_with_contract: 'Con contrato',
      onus_without_contract: 'Sin contrato',
      operate_status: 'Operate status',
      operation_id: 'Operation ID',
      optical_info: 'Información Óptica',
      optical_power_precision: 'Optical power precision',
      phase_state: 'Phase state',
      nap_port: 'Puerto NAP',
      ping_response: 'Ping response',
      pon: 'Uplink PON',
      pon_if_number: 'PONIF Count',
      port_identifier: 'ID puerto',
      port_identifier_eq: 'ID Puerto',
      ports: 'Puertos',
      ports_numbers: 'Número de puertos',
      pots: 'POTS',
      pots_uni_number: 'POTS UNI number',
      pppoe_mode: 'PPPoE mode',
      pppoe_proxy: 'PPPoE proxy',
      pppoe_service_name: 'PPPoE service name',
      pppoe_serv_name: 'PPPoE serv name',
      pps_to_d: 'PPS to D',
      prefix_access_mode: 'Prefix access mode',
      prefix_preferred_time: 'Prefix preferred time',
      prefix_valid_time: 'Prefix valid time',
      pri_profile_id: 'Pri profile ID',
      primary_dns: 'Primary DNS',
      priority_policy: 'Priority policy',
      product_code: 'Product code',
      product_id: 'ID de producto',
      product_sn: 'Product serial number',
      profiles_info: 'Información de perfiles',
      protection_type: 'Protection type',
      qinq_enable: 'QinQ?',
      qos_enable: 'QoS?',
      qosenable: 'QoS?',
      qos_mode: 'QoS mode',
      region_code: 'Region code',
      registration_info: 'Información de registro',
      ring_check_switch: 'Ring check switch',
      ring_check_detect_frequency: 'Ring check detect frequency',
      ring_detect_frequency: 'Ring detect frequency',
      ring_port_auto_shutdown: 'Ring port auto shutdown',
      ring_resume_interval: 'Ring resume interval',
      rtt: 'RTT',
      rtt_tq: 'RTT',
      run_state: 'Run state',
      rx_power: 'RX Power',
      rx_power_current_alarm_threshold: 'RX power current alarm threshold',
      rx_power_current_warning_threshold: 'RX power current warning threshold',
      rx_optical_power: 'RX Power',
      second_dns: 'Secondary DNS',
      security_capability: 'Security capability',
      security_mode: 'Security mode',
      serial: 'Número de serie',
      serial_number: 'Número de serie',
      serial_number_i_cont: 'Número de serie',
      service_profile: 'Service profile',
      service_profile_id: 'Service profile ID',
      service_profile_name: 'Service profile name',
      slave_dns: 'DNS 2',
      slot: 'Slot',
      slot_number: 'Slot Count',
      service_type: 'Service type',
      sn: 'Número de serie',
      sn_bind: 'SN bind',
      software_version: 'Versión del Software',
      software_work_mode: 'Software work mode',
      standby_software_is_active: 'Standby software is active',
      standby_software_is_commit: 'Standby software is commit',
      standby_software_version: 'Standby software version',
      subnet_mask: 'Mascara de subred',
      supply_voltage: 'Tensión de alimentación',
      supply_voltage_alarm_threshold: 'Supply voltage alarm threshold',
      supply_voltage_warning_threshold: 'Supply voltage warning threshold',
      support_xml_version: 'Support XML version',
      survival_time: 'Survival time',
      switch: 'Switch',
      sysuptime: 'SysUp Time',
      tag_action: 'Tag action',
      t_cont_0_dba_profile_id: 'TCONT 0 DBA profile ID',
      t_cont_1_dba_profile_id: 'TCONT 1 DBA profile ID',
      tcont_number: 'TCONT number',
      tdm: 'TDM',
      tdm_port_type: 'TDM port type',
      tdm_service_type: 'TDM service type',
      temperature: 'Temperatura',
      temperature_alarm_threshold: 'Temperature alarm threshold',
      temperature_warning_threshold: 'Temperature warning threshold',
      the_type_of_flow_control: 'Flow control type',
      total_priority_queue_num: 'Total priority queue num',
      total_priority_queue_number: 'Total priority queue number',
      total_traffic_schedule_num: 'Total traffic schedule num',
      total_uni_number: 'Total UNI number',
      totalgemportnum: 'Total GEM port number',
      tr069_ip_index: 'TR069 IP index',
      tr069_management: 'TR069',
      tr069_profile: 'TR069 profile',
      traceroute_response: 'Traceroute response',
      traffic_management_option: 'Traffic management option',
      traffic_profile_id: 'Traffic profile ID',
      traffic_profile_name: 'Traffic profile name',
      traffic_profile_pir: 'Traffic profile PIR',
      traffic_scheduler_number: 'Traffic scheduler number',
      tx_bias_current: 'TX Bias Current',
      tx_bias_current_warning_threshold: 'TX bias current warning threshold',
      tx_bias_current_alarm_threshold: 'TX bias current alarm threshold',
      tx_power: 'TX Power',
      tx_power_current_alarm_threshold: 'TX power current alarm threshold',
      tx_power_current_warning_threshold: 'TX power current warning threshold',
      tx_optical_power: 'TX Power',
      tx_power_supply_control: 'TX power supply control',
      type_c_support: 'Type C support',
      unauthorized_onts: 'ONUs sin autorizar',
      up_priority_queue_number: 'Up priority queue number',
      upgrade: 'Upgrade',
      upstream: 'Upstream',
      upstream_igmp_packet_forward_mode: 'Upstream IGMP packet forward mode',
      upstream_igmp_packet_priority: 'Upstream IGMP packet priority',
      upstream_igmp_packet_forward_vlan: 'Upstream IGMP packet forward vlan',
      upstream_pq_color_policy: 'Upstream PQ color policy',
      used_type: 'Used type',
      validity_mode: 'Validity mode',
      vdsl: 'VDSL',
      veip: 'VEIP',
      veip_number: 'VEIP number',
      veip_uni_number: 'VEIP UNI number',
      vendor_id: 'Vendor ID',
      vendor_name: 'Vendor name',
      vendor_pn: 'Vendor PN',
      vendor_rev: 'Vendor rev',
      vendor_sn: 'Vendor SN',
      video_uni_number: 'Video UNI number',
      vlan: 'Vlan',
      vlans: 'Vlans',
      vlan_cos: 'Vlan cos',
      vlan_id: 'Vlan ID',
      vlan_identifier_eq: 'Vlan',
      vlan_lines: 'Vlan ID Servidor <=> Cliente',
      vlan_mode: 'Vlan Mode',
      vlan_priority: 'Vlan priority',
      vo_ip_configure_method: 'VoIP configure method',
      vport_mode: 'Vport mode',
      voltage: 'Voltaje',
      wan_conn_mode: 'Wan conn mode',
      wan_conn_type: 'Wan conn type',
      wan_cos: 'Wan cos',
      wan_gateway: 'Wan gateway',
      wan_id: 'WAN ID',
      wan_info: 'Wan',
      wan_ip_address: 'Wan ip address',
      wan_ip_netmask: 'Wan ip netmask',
      wan_master_dns: 'Wan master dns',
      wan_mode: 'Wan Mode',
      wan_mtu: 'Wan MTU',
      wanmtu: 'Wan MTU',
      wan_name: 'Wan name',
      wan_nat_enable: 'Wan NAT enable',
      wan_profile_id: 'WAN profile ID',
      wan_slave_dns: 'Wan slave dns',
      wan_status: 'Wan status',
      wan_vlan_id: 'Wan Vlan id',
      wifi_uni_number: 'WiFi UNI number',
      x_dsl_uni_number: 'xDSL UNI number',
      xdsl_uni_number: 'xDSL UNI number',
      xge: '10 Gigabit Ethernet',
      link_ont_message:
        'Al vincular un Contrato con una ONU, no se realizarán cambios en la OLT y se mantendrá la configuración actual. No podrá realizar acciones de Control de ancho de banda y aprovisionamiento WAN.',
      reconfigure_ont_message:
        'Al reescribir la configuración, se desautorizará la ONU y se volverá autorizar y configurar con toda la información establecida en el Contrato.',
      olt_rx_ont_power: 'RX OLT Power'
    },
    olt: {
      alarm_power_threshold: 'Umbral de Potencias para Alarmas dBm',
      allow_only_allowed_contracts_to_navigate: 'Desactivar ONUs de contratos deshabilitados',
      brand: 'Marca',
      brand_eq: 'Marca',
      catv_control_enabled: 'Control de CATV',
      cron_stats_enabled: 'Cron Habilitado',
      dns_first_server: 'Primer servidor DNS',
      dns_second_server: 'Segundo servidor DNS',
      equipment_model: 'Modelo',
      equipment_model_eq: 'Modelo',
      extra_vlans: 'Extra Vlans',
      fiber_id: 'Fibra (ID)',
      host: 'Host',
      host_cont: 'Host',
      kind: 'Tipo OLT',
      kind_eq: 'Tipo OLT',
      name: 'Nombre',
      navigation_vlan: 'Vlan',
      olt_wan_provisioning: 'Aprovisionar WAN',
      ont_custom_tr069_profile: 'Perfil TR069',
      ont_custom_tr069_profile_hint: 'Escribe el profile-name del Perfil TR069 a utilizar.',
      onts_consumption_enabled: 'Habilitar gráficos de contratos',
      pass: 'Contraseña',
      port: 'Puerto',
      port_cont: 'Puerto',
      private_host: 'Host privado',
      rx_power_critical_lower: 'RX power critical lower',
      rx_power_critical_upper: 'RX power critical upper',
      rx_power_warning_lower: 'RX power warning lower',
      rx_power_warning_upper: 'RX power warning upper',
      snmp_consumption_enabled: 'Habilitar gráficos de consumo',
      snmp_port: 'Puerto SNMP',
      ssh_port: 'Puerto SSH',
      state_eq: 'Estado',
      state_eq_both: 'Ambos',
      state_eq_free: 'No Vinculados',
      state_eq_linked: 'Vinculados',
      stats_user: 'User stats',
      telnet_port: 'Puerto Telnet',
      tr069_profile: 'Perfil TR069',
      traffic_control_enabled: 'Control de ancho de banda',
      zoneables_zone_ids: 'Zona'
    },
    olt_server_interfaces: {
      olt_id_eq: 'OLT',
      server_configuration_id_eq: 'Servidor',
      vlan_id_eq: 'VLAN'
    },
    orders: {
      order: {
        end_at: 'Termina el',
        kinds: {
          installation: 'Instalación',
          technical: 'Técnica',
          resignation: 'Baja',
          maintenance: 'Mantenimiento',
          feasibility: 'Factibilidad'
        },
        start_at: 'Inicia el',
        states: {
          pending: 'Pendiente',
          to_reschedule: 'Reprogramar',
          finalized: 'Finalizada',
          closed: 'Cerrada'
        },
        result: 'Resultado',
        results: {
          success: 'Exitosa',
          failure: 'Fallida'
        }
      }
    },
    owner: {
      last_name: 'Apellido',
      payment_by_transfer: 'Cobro por transferencia',
      payment_on_account: 'Cobro a cuenta',
      referral_payment_details: 'Datos bancarios',
      referral_payment_method: 'Método de pago',
      referral_payment_preferences: 'Preferencias de cobro de comisiones',
      referred_by: 'Código de referencia',
      unspecified: 'No especificado'
    },
    payment_method: {
      counted: 'Contado',
      credit: 'Credito',
      credit_visa: 'Visa Crédito',
      debit_visa: 'Visa Débito',
      deferred_or_installments_payment: 'PPD - Pago en parcialidades o diferido',
      mastercard: 'MasterCard',
      other: 'Otro',
      single_payment: 'PUE - Pago en una sola exhibición'
    },
    payment_promise: {
      expiration_filter_expired: 'Expirada',
      expiration_filter_not_expired: 'Vigente',
      expiration_filter_both: 'Ambos',
      mobile_filter_mobile: 'AppMobile',
      mobile_filter_not_mobile: 'WisproCloud / API',
      mobile_filter_both: 'Ambos',
      created_at_gteq: 'Creado el (desde)',
      // created_at_lteq: 'Creado el (hasta)',
      creator_name: 'Creador',
      creator_clients: 'Creador (Cliente desde AppMobile)',
      creator_users: 'Creador (Empleado/Dueño)',
      expiration_filter: 'Estado',
      mobile_filter: 'Creado desde',
      placeholder_creator_clients: 'Puedes seleccionar Clientes',
      placeholder_creator_users: 'Puedes seleccionar Empleados/Dueño',
      user_id_eq: 'Creador',
      valid_until: 'Valido hasta',
      valid_until_gteq: 'Valido (desde)',
      valid_until_lteq: 'Valido (hasta)'
    },
    payment_way: {
      peru: {
        down_payment: '001 - Deposito en cuenta',
        remittance: '002 - Giro',
        transfer_of_funds: '003 - Transferencia de fondos',
        payment_order: '004 - Orden de pago',
        debit_card: '005 - Tarjeta de debito',
        credit_card: '006 - Tarjeta de credito',
        check: '007 - Cheque',
        cash: '009 - Efectivo',
        other: '999 - Otros medios de pago'
      },
      mexico: {
        cash: '01 - Efectivo',
        nominal_check: '02 - Cheque nominativo',
        electronic_transfer: '03 - Transferencia electrónica de fondos',
        credit_card: '04 - Tarjeta de crédito',
        debit_card: '28 - Tarjeta de débito',
        to_define: '99 - Por definir'
      },
      ecuador: {
        without_financial_system: '01 - Sin utilización del sistema financiero',
        debt_compensation: '15 - Compensación de deudas',
        debit_card: '16 - Tarjeta de débito',
        electronic_money: '17 - Dinero electrónico',
        prepaid_card: '18 - Tarjeta prepago',
        credit_card: '19 - Tarjeta de crédito',
        others_with_financial_system: '20 - Otros con utilización del sistema financiero',
        title_endorsement: '21 - Endoso de títulos'
      },
      colombia: {
        undefined_instrument: '1 - Instrumento no definido',
        ach_credit: '2 - Crédito ACH',
        ach_debit: '3 - Débito ACH',
        ach_demand_debit_reversal: '4 - Reversión débito de demanda ACH',
        ach_demand_credit_reversal: '5 - Reversión crédito de demanda ACH',
        ach_demand_debit: '6 - Crédito de demanda ACH',
        ach_demand_credit: '7 - Débito de demanda ACH',
        hold: '8 - Mantener',
        national_or_regional_clearing: '9 - Clearing Nacional o Regional',
        cash: '10 - Efectivo',
        reversal_credit_savings: '11 - Reversión Crédito Ahorro',
        reversal_debit_savings: '12 - Reversión Débito Ahorro',
        credit_savings: '13 - Crédito Ahorro',
        debit_savings: '14 - Débito Ahorro',
        bookentry_credit: '15 - Bookentry Crédito',
        bookentry_debit: '16 - Bookentry Débito',
        concentration_of_demand_in_cash_disbursement_credit:
          //   '17 - Concentración de la demanda en efectivo/Desembolso Crédito (CCD)',
          // concentration_of_demand_in_cash_disbursement_credit:
          '18 - Concentración de la demanda en efectivo /Desembolso Débito (CCD)',
        corporate_business_payment_credit: '19 - Crédito Pago negocio corporativo (CTP)',
        check: '20 - Cheque',
        banking_project: '21 - Proyecto bancario',
        certified_bank_project: '22 - Proyecto bancario certificado',
        bank_check: '23 - Cheque bancario',
        Foreign_exchange_note_awaiting_acceptance: '24 - Nota cambiaria esperando aceptación',
        certified_check: '25 - Cheque certificado',
        local_check: '26 - Cheque Local',
        debit_payment_corporate_business: '27 - Débito Pago Negocio Corporativo (CTP)',
        credit_business_corporate_exchange: '28 - Crédito Negocio Intercambio Corporativo (CTX)',
        debit_business_exchange_corporate: '29 - Débito Negocio Intercambio Corporativo (CTX)',
        credit_transfer: '30 - Transferencia Crédito',
        debit_transfer: '31 - Transferencia Débito',
        concentration_cash_disbursement_credit_plus: '32 - Concentración Efectivo / Desembolso Crédito plus (CCD+)',
        concentration_cash_disbursement_debit_plus: '33 - Concentración Efectivo / Desembolso Débito plus (CCD+)',
        pre_agreed_payment_and_deposit: '34 - Pago y depósito pre acordado (PPD)',
        cash_concentration_savings_credit_disbursement:
          '35 - Concentración efectivo ahorros / Desembolso Crédito (CCD)',
        cash_concentration_savings_debit_disbursement: '36 - Concentración efectivo ahorros / Desembolso Débito (CCD)',
        payment_corporate_business_savings_credit: '37 - Pago Negocio Corporativo Ahorros Crédito (CTP)',
        payment_corporate_business_savings_debit: '38 - Pago Negocio Corporativo Ahorros Débito (CTP)',
        corporate_exchange_business_credit: '39 - Crédito Negocio Intercambio Corporativo (CTX)',
        corporate_exchange_business_debit: '40 - Débito Negocio Intercambio Corporativo (CTX)',
        cash_concentration_credit_disbursement_plus: '41 - Concentración efectivo/Desembolso Crédito plus (CCD+)',
        cash_concentration_debit_disbursement_plus: '42 - Concentración efectivo/Desembolso Débito plus (CCD+)',
        bank_deposit: '43 - Consignación bancaria',
        note_would_exchange: '44 - Nota cambiaría',
        bank_credit_transfer: '45 - Transferencia Crédito Bancario',
        interbank_debit_transfer: '46 - Transferencia Débito Interbancario',
        bank_debit_transfer: '47 - Transferencia Débito Bancaria',
        credit_card: '48 - Tarjeta Crédito',
        debit_card: '49 - Tarjeta Débito',
        post_spin: '50 - Postgiro',
        french_banking_standard_telex: '51 - Telex estándar bancario francés',
        urgent_business_payment: '52 - Pago comercial urgente',
        urgent_treasury_payment: '53 - Pago Tesorería Urgente',
        promissory_note: '60 - Nota promisoria',
        promissory_note_signed_by_the_creditor: '61 - Nota promisoria firmada por el acreedor',
        promissory_note_signed_by_the_creditor_guaranteed_by_the_bank:
          '62 - Nota promisoria firmada por el acreedor, avalada por el banco',
        promissory_note_signed_by_the_creditor_endorsed_by_third:
          '63 - Nota promisoria firmada por el acreedor, avalada por un tercero',
        promissory_note_signed_by_the_bank: '64 - Nota promisoria firmada por el banco',
        promissory_note_signed_by_bank_guaranteed_by_another_bank:
          '65 - Nota promisoria firmada por un banco avalada por otro banco',
        signed_promissory_note: '66 - Nota promisoria firmada',
        promissory_note_signed_by_a_third_party_endorsed_by_bank:
          '67 - Nota promisoria firmada por un tercero avalada por un banco',
        withdrawal_of_note_by_the_creditor: '70 - Retiro de nota por el por el acreedor',
        bonuses: '71 - Bonos',
        vouchers: '72 - Vales',
        withdrawal_of_note_by_the_creditor_on_bank: '74 - Retiro de nota por el por el acreedor sobre un banco',
        withdrawal_of_note_by_the_creditor_guaranteed_by_another_bank:
          '75 - Retiro de nota por el acreedor, avalada por otro banco',
        Withdrawal_of_note_by_the_creditor_on_bank_guaranteed_by_third_party:
          '76 - Retiro de nota por el acreedor, sobre un banco avalada porun tercero',
        withdrawal_of_note_by_the_creditor_on_third_party: '77 - Retiro de una nota por el acreedor sobre un tercero',
        withdrawal_of_note_by_the_treditor_on_third_party_guaranteed_by_bank:
          '78 - Retiro de una nota por el acreedor sobre un tercero avalada por un banco',
        transferable_bank_note: '91 - Nota bancaria transferible',
        local_transferable_check: '92 - Cheque local transferible',
        referenced_turn: '93 - Giro referenciado',
        urgent_turn: '94 - Giro urgente',
        open_format_turn: '95 - Giro formato abierto',
        requested_payment_method_not_used: '96 - Método de pago solicitado no usado',
        clearing_between_partners: '97 - Clearing entre partners',
        mutual_agreement: 'ZZZ - Acuerdo mutuo'
      }
    },
    plan: {
      no_policy_to_edit: 'No tiene permisos para editar el contrato',
      no_policy_to_audits: 'No tiene permisos para ver las auditorias',
      app_visibility: 'Visible en la App',
      burst_down: 'Ráfagas Bajada',
      burst_duration: 'Duración de Ráfaga ',
      burst_enable: 'Ráfagas habilitadas',
      burst_enabled: 'Ráfagas habilitadas',
      burst_enabled_eq_both: 'Ambos',
      burst_enabled_eq_disabled: 'Deshabilitado',
      burst_enabled_eq_enabled: 'Habilitado',
      burst_limit: 'Ráfaga máxima',
      burst_limit_down: 'Ráfaga Máx. Bajada',
      burst_limit_down_human: 'Ráfaga Máx. Bajada',
      burst_limit_down_unit: 'Ráfaga Máx. Bajada',
      burst_limit_down_unit_bps: 'bps',
      burst_limit_down_unit_kbps: 'kbps',
      burst_limit_down_unit_mbps: 'Mbps',
      burst_limit_down_unit_gbps: 'Gbps',
      burst_limit_up: 'Ráfaga Máx. subida',
      burst_limit_up_human: 'Ráfaga Máx. Subida',
      burst_limit_up_unit: 'Ráfaga Máx. subida',
      burst_limit_up_unit_bps: 'bps',
      burst_limit_up_unit_kbps: 'kbps',
      burst_limit_up_unit_mbps: 'Mbps',
      burst_limit_up_unit_gbps: 'Gbps',
      burst_threshold_down: 'Límite bajada (threshold)',
      burst_threshold_down_human: 'Límite bajada (threshold)',
      burst_threshold_down_unit: 'Límite bajada (threshold)',
      burst_threshold_down_unit_bps: 'bps',
      burst_threshold_down_unit_kbps: 'kbps',
      burst_threshold_down_unit_mbps: 'Mbps',
      burst_threshold_down_unit_gbps: 'Gbps',
      burst_threshold_up: 'Límite subida (threshold)',
      burst_threshold_up_human: 'Límite subida (threshold)',
      burst_threshold_up_unit: 'Límite subida (threshold)',
      burst_threshold_up_unit_bps: 'bps',
      burst_threshold_up_unit_kbps: 'kbps',
      burst_threshold_up_unit_mbps: 'Mbps',
      burst_threshold_up_unit_gbps: 'Gbps',
      burst_time_down: 'Chequeo activación de Ráfaga de bajada',
      burst_time_up: 'Chequeo activación de Ráfaga de subida',
      burst_up: 'Ráfagas subida',
      ceil: 'Máx. Subida / Máx. Bajada',
      ceil_down: 'Máx. Bajada',
      ceil_down_human: 'Máx. Bajada',
      ceil_down_unit: 'Unidad de bajada',
      ceil_down_unit_bps: 'bps',
      ceil_down_unit_kbps: 'kbps',
      ceil_down_unit_mbps: 'Mbps',
      ceil_down_unit_gbps: 'Gbps',
      ceil_up: 'Máx. Subida',
      ceil_up_human: 'Máx. Subida',
      ceil_up_unit: 'Unidad de subida',
      ceil_up_unit_bps: 'bps',
      ceil_up_unit_kbps: 'kbps',
      ceil_up_unit_mbps: 'Mbps',
      ceil_up_unit_gbps: 'Gbps',
      cir_percentage: 'Valor de porcentaje',
      cir_strategy: 'Estrategia de ancho de banda garantizado',
      cir_strategy_eq_automatic: 'Automatico',
      cir_strategy_eq_both: 'Ambos',
      cir_strategy_eq_percentage: 'Porcentaje',
      cir_strategy_percentage: 'Porcentaje',
      clock_control: 'Control horario',
      degraded_percent: 'Porcentaje de degradado',
      down: 'bajada',
      installation_price: 'Precio de instalación',
      invoicing_plan_attributes: {
        first_surcharge_product_code: 'Código de producto interes primer vencimiento',
        installation_price: 'Precio de instalación',
        installation_product_code: 'Código de producto de instalación',
        invoicing_frecuency: {
          ['1']: 'Mensual',
          ['2']: 'Bimestral',
          ['3']: 'Trimestral',
          ['4']: 'Cuatrimestral',
          ['6']: 'Semestral',
          ['12']: 'Anual'
        },
        price: 'Precio',
        product_code: 'Código de producto',
        reconnection_charge_product_code: 'Código de producto cargo por reconexión',
        second_surcharge_product_code: 'Código de producto interés segundo vencimiento'
      },
      long_download_max: 'Límite para descargas grandes [kbytes]',
      long_upload_max: 'Límite para cargas grandes [kbytes]',
      mikrotik_cir: 'CIR',
      mikrotik_strategy: 'Estrategia de ancho de banda',
      mikrotik_strategy_eq_all: 'Todas',
      mikrotik_strategy_eq_pcq_with_queue_tree: 'PCQ con árbol de colas',
      mikrotik_strategy_eq_pcq_with_simple_queue: 'PCQ con colas simples',
      mikrotik_strategy_eq_simple_queue: 'Colas simples',
      mikrotik_strategy_simple_queue_with_cake: 'Colas simples con cake',
      number_of_contracts: 'Cantidad de contratos',
      public_for_mobile_eq_both: 'Ambos',
      public_for_mobile_eq_disabled: 'Deshabilitado',
      public_for_mobile_eq_enabled: 'Habilitado',
      rate_down: 'Mín. bajada',
      rate_up: 'Mín. subida',
      simple_queue_with_cake: 'Colas simples con cake',
      simple_queue_with_cake_warning:
        'Precaución: utilizar colas simples con cake genera un mayor consumo de memoria RAM.',
      strategy_bandwidth: 'Estrategia de ancho de banda garantizado',
      tax_one_id: 'Impuesto',
      time_ceil_down: 'Máx. bajada',
      time_ceil_down_human: 'Máx. bajada',
      time_ceil_down_unit: 'Unidad de bajada',
      time_ceil_down_unit_bps: 'bps',
      time_ceil_down_unit_kbps: 'kbps',
      time_ceil_down_unit_mbps: 'Mbps',
      time_ceil_down_unit_gbps: 'Gbps',
      time_ceil_up: 'Máx. subida',
      time_ceil_up_human: 'Máx. subida',
      time_ceil_up_unit: 'Unidad de subida',
      time_ceil_up_unit_bps: 'bps',
      time_ceil_up_unit_kbps: 'kbps',
      time_ceil_up_unit_mbps: 'Mbps',
      time_ceil_up_unit_gbps: 'Gbps',
      time_enabled: 'Control horario habilitado',
      time_enabled_eq_both: 'Ambos',
      time_enabled_eq_disabled: 'Deshabilitado',
      time_enabled_eq_enabled: 'Habilitado',
      time_friday: 'viernes',
      time_from: 'Desde',
      time_monday: 'lunes',
      time_saturday: 'sabados',
      time_sunday: 'domingos',
      time_thursday: 'jueves',
      time_to: 'Hasta',
      time_tuesday: 'martes',
      time_wednesday: 'miércoles',
      title_burst_down: 'Ráfagas bajada',
      title_burst_up: 'Ráfagas subida',
      title_invoicing: 'Facturación',
      tool_tips: {
        burst_duration: 'Duración de Ráfaga (Segundos)',
        burst_limit_down: 'Velocidad máxima de descarga de datos que se puede alcanzar mientras se permite la ráfaga',
        burst_limit_up: 'Velocidad de datos de carga máxima que se puede alcanzar mientras se permite la ráfaga',
        burst_threshold_down: 'Este es el valor de encendido/apagado de ráfaga de descarga',
        burst_threshold_up: 'Este es el valor de encendido/apagado de ráfaga de carga',
        burst_time_down:
          'Periodo de tiempo, en segundos, durante el cual se calcula la velocidad de datos promedio de descarga.(Este NO es el momento de la rafaga real)',
        burst_time_up:
          'Periodo de tiempo, en segundos, durante el cual se calcula la velocidad de datos promedio de carga.(Este NO es el momento de la ráfaga real)',
        cir: 'Porcentaje de ancho de banda a garantizar a cada contrato',
        cir_strategy_bmu: 'Estrategia a utilizar para de ancho de banda',
        mikrotik_cir: 'Porcentaje de ancho de banda a garantizar a cada contrato',
        mikrotik_strategy: 'Estrategia a utilizar para la distribución de ancho de banda',
        total_contracts_bmu: 'Total de contratos asignados Bmu',
        total_contracts_mikrotik: 'Total de contratos asignados a Mikrotik'
      },
      unlimited: 'Ilimitado',
      up: 'subida',
      week: {
        time_friday: 'Viernes',
        time_monday: 'Lunes',
        time_saturday: 'Sabado',
        time_sunday: 'Domingo',
        time_thursday: 'Jueves',
        time_tuesday: 'Martes',
        time_wednesday: 'Miercoles'
      },
      week_indication: 'Debe seleccionar el día o los días en el que se desea que comience el control horario.'
    },
    portal_configuration: {
      change_plan_mobile_setting: 'Cambio de plan desde app móvil',
      company_isotype_title: 'Isotipo del ISP',
      contract_alerted_sms_notification: 'Notificación SMS contrato alertado',
      contract_disabled_sms_notification: 'Notificación SMS contrato deshabilitado',
      contract_graphs_enabled: 'Gráficos de Contratos',
      create_issue_mobile_setting: 'Creación de tickets desde app móvil',
      create_payment_promise_mobile_setting: 'Creación de promesas de pago desde app móvil',
      disabled_contract_push_notification: 'Notificación movil contrato deshabilitado',
      email: 'E-mail de contacto',
      enabled: 'Estado del portal',
      finalized_issue_push_notification: 'Notificación movil ticket finalizado',
      first_due_date_invoice_push_notification: 'Notificación movil primer Vencimiento factura',
      issue_invoice_push_notification: 'Notificación movil factura emitida',
      issued_invoice_sms_notification: 'Notificación SMS factura emitida',
      locale: 'es',
      new_payment_push_notification: 'Notificación movil nuevo pago',
      phone: 'Teléfono fijo',
      phone_mobile: 'Teléfono celular',
      portal_logo: 'Logo del Portal',
      portal_logo_title: 'Logo del Portal',
      second_due_date_invoice_push_notification: 'Notificación movil segundo Vencimiento factura',
      telegram_phone: 'Telegram',
      whatsapp_phone: 'Whatsapp',
      wifi_mobile_setting: 'Visualización configuración wifi desde app móvil'
    },
    ppp_profile: {
      lan_prefixes_dhcpv6_pd_pool: 'Prefijos Lan (DHCPv6 PD Pool)',
      wan_prefixes_remote_ipv6: 'Prefijos Wan (Remote IPv6 Prefix Pool)',
      ceil_down_human: 'Max. bajada',
      ceil_down_unit: 'Unidad máx. de bajada',
      ceil_down_unit_bps: 'bps',
      ceil_down_unit_kbps: 'kbps',
      ceil_down_unit_mbps: 'Mbps',
      ceil_down_unit_gbps: 'Gbps',
      ceil_up_human: 'Max. subida',
      ceil_up_unit: 'Unidad máx. de subida',
      ceil_up_unit_bps: 'bps',
      ceil_up_unit_kbps: 'kbps',
      ceil_up_unit_mbps: 'Mbps',
      ceil_up_unit_gbps: 'Gbps',
      custom_ceil_down: 'Máx. bajada',
      custom_ceil_up: 'Máx. subida',
      mikrotik_dns_server_one: 'Primer servidor DNS',
      mikrotik_dns_server_three: 'Tercer servidor DNS',
      mikrotik_dns_server_two: 'Segundo servidor DNS',
      remote_ipv6_prefix_pool: 'Pool de prefijos IPv6 remoto',
      server_configuration_id: 'Servidor',
      use_rate_limit: 'Usar límite de velocidad'
    },
    provider: {
      online: 'En línea',
      online_changed_at: 'Cambio de estado',
      rate_down: 'Bajada',
      rate_up: 'Subida'
    },
    provider_group: {
      providers: 'Proveedores',
      public_ip: 'IP Pública',
      rate_down: 'Bajada',
      rate_download: 'Descarga',
      rate_up: 'Subida',
      simultaneity_down_index: 'Indice Bajada',
      simultaneity_up_index: 'Indice Subida'
    },
    push_notification_device: {
      add_all_clients: 'Agregar todos',
      add_clients: 'Agregar Clientes',
      clients_selected: 'Clientes Seleccionados',
      confirm_add_all: 'Agregar Todos',
      confirm_add_selected: 'Agregar Seleccionados',
      confirm_remove_all: 'Eliminar Todos',
      confirm_remove_selected: 'Eliminar Seleccionado',
      custom_no_record_message_add: 'No hay Clientes disponibles para agregar',
      custom_no_record_message_remove: 'No hay Clientes disponibles para borrar',
      destroy_clients: 'Eliminar Clientes',
      destroy_filtered_clients: 'Borrar',
      detail: 'Detalle',
      disabled_contract_push_notification: 'Contrato Deshabilitado',
      dual_list: {
        hint: 'Solo se mostrarán los clientes que tengan la Aplicación Alerta Internet instalada.'
      },
      edit_notification_mobile: 'Editar Notificación',
      error_message: 'No hay Notificaciones que mostrar',
      existing: 'Existente',
      filter: {
        default_pending_invoices: 'Ambos',
        title: 'Filtrar por estatus',
        with_pending_invoices: 'Deudores',
        without_pending_invoices: 'Sin Deuda'
      },
      filter_placeholder: 'Nombre de Clientes',
      filter_typeahead_placeholder: 'Filtre por Nombre',
      finalized_issue_push_notification: 'Ticket Finalizado',
      first_due_date_invoice_push_notification: 'Primer Vencimiento',
      form: {
        hint: 'Una vez creada la notificación tendrá 15 minutos para poder editarla o eliminarla, luego será enviada' // title: 'Titulo'
      },
      hint: {
        disabled_contract_push_notification:
          'Cada vez que se deshabilite un contrato en el sistema se enviará una notificación al cliente.',
        finalized_issue_push_notification:
          'Cada vez que se finalice un ticket en el sistema se enviará una notificación al cliente.',
        first_due_date_invoice_push_notification:
          'Cada vez que se cumpla la primer fecha de vencimiento de una factura se enviará una notificación al cliente.',
        issue_invoice_push_notification:
          'Cada vez que se emita una factura en el sistema se enviará una notificación al cliente.',
        new_payment_push_notification:
          'Cada vez que se cargue un pago en el sistema se enviará una notificación al cliente.',
        second_due_date_invoice_push_notification:
          'Cada vez que se cumpla la segunda fecha de vencimiento de una factura se enviará una notificación al cliente.'
      },
      invoice_push_notification: 'Factura Emitida',
      is_pending_message: 'Tu información esta siendo procesada',
      issue_invoice_push_notification: 'Factura Emitida',
      kind: 'Evento',
      label_state: {
        failure: {
          one: 'Fallo',
          other: 'Fallidas'
        },
        pending: {
          one: 'Pendiente',
          other: 'Pendientes'
        },
        success: {
          one: 'Exitosa',
          other: 'Exitosas'
        }
      },
      manage_clients: 'Administrar Clientes',
      new_notification_mobile: 'Nueva Notificación',
      new_payment_push_notification: 'Nuevo Pago',
      notification_placeholder: 'Titulo, Detalle',
      payment_push_notification: 'Nuevo Pago',
      placeholder_contracts_coverage_node_id_eq: 'Nodo',
      placeholder_contracts_plan_id_eq: 'Plan',
      placeholder_contracts_server_configuration_id_eq: 'Servidores',
      placeholder_invoicing_client_invoicing_firm_id_eq: 'Razon Social',
      placeholder_neighborhood_id_eq: 'Barrios',
      placeholder_zoneables_zone_id_eq: 'Zonas',
      pnd_basic_placeholder: 'Busca por Zonas, Barrios, Servidores, Razón social, Planes, Nodos',
      push_error_message: 'No hay clientes con notificaciones',
      push_notification_detail: 'Detalle de la notificación',
      push_notification_detail_devices: 'La notificación se envio a ',
      second_due_date_invoice_push_notification: 'Segundo Vencimiento',
      setting_title: 'Configuración de notificaciones preestablecidas',
      status_eq_any: 'Estado de la Notificación',
      time_remaining: 'Se Enviará en',
      tooltips: {
        list_of_notification_devices: 'Lista de Notificaciones Push'
      }
    },
    referral: {
      active_referees: 'Activos',
      completed: 'Finalizado',
      conversion_date: 'Activado el',
      created_on: 'Creado el',
      debits: 'Total cobrado',
      lost: 'No convertido',
      paid_payments: 'Total acreditado',
      payment: {
        due: 'Pendiente',
        due_date: 'Fecha de pago',
        lost: 'Inválido',
        paid: 'Pagado'
      },
      payment_details: 'Detalles de cobro',
      referee: 'Referido',
      referrer: 'Referente',
      tooltip: {
        activation_date: 'Fecha de activación',
        balance: 'Balance de comisiones por cobrar',
        conversion_date: 'Fecha de conversión',
        debits: 'Total de comisiones cobradas',
        no_payment_details: 'Falta proporcionar datos bancarios',
        paid: 'Pago acreditado',
        paid_payments:
          'Total de comisiones acreditadas por este referido. El pago se realiza según sus preferencias de cobro.',
        pending: 'Número de pagos por cobrar por este referido'
      },
      transaction_for: 'Transacción para'
    },
    sale_desk: {
      lead: {},
      prospect: {
        no_lead_selected_title: 'No hay Lead seleccionado',
        no_lead_selected_text: 'Elige uno en el input de Leads',
        from_unconverted_leads: 'Leads no convertidos',
        states: {
          captured: 'Capturado',
          converted: 'Convertido',
          rejected: 'Rechazado',
          deleted: 'Eliminado'
        }
      },
      ticket: {
        state: {
          pending: 'Pendiente',
          pending_order: 'Orden pendiente',
          assigned: 'Asignado',
          finalized: 'Finalizado',
          closed: 'Cerrado',
          reopened: 'Reabierto'
        },
        result: 'Resultado',
        results: {
          success: 'Exitoso',
          failure: 'Fallido'
        }
      }
    },
    seal: {
      code: 'Código',
      nap_id: 'NAP',
      // code: {
      //   unit: {
      //     create_unit_seal: 'Ingrese un código y presione Enter'
      //   }
      // },
      code_range_filter: 'Buscar por rango',
      create_form_preview_title: 'No hay códigos para mostrar.',
      create_form_preview_message: 'Añade uno para previsualizarlo.',
      create_new_seal: 'Crear nuevo Precinto',
      has_contracts_filter_both: 'Ambos',
      has_contracts_filter_with: 'Disponibles',
      has_contracts_filter_without: 'En uso',
      limit_seal: 'Has alcanzado el límite de creación de precintos (1000)',
      placeholder_basic_search: 'Puedes buscar por: Código, Nombre Nap.',
      prefix: 'Prefijo',
      preview: 'Vista previa',
      sequential_id_gteq: 'ID Precinto (Desde)',
      sequential_id_lteq: 'ID Precinto (Hasta)',
      start_end: 'Rango(Fin)',
      start_range: 'Rango(Inicio)',
      suffix: 'Sufijo'
    },
    search: {
      not_paged: 'No Paginar'
    },
    sent_sms: {
      sent_at_gteq: 'Enviado el (Desde)',
      sent_at_lteq: 'Enviado el (Hasta)'
    },
    server_configuration: {
      allow_only_allowed_contracts_to_navigate: 'Sólo permitir navegar a los contratos permitidos',
      cable_modem_service_enabled: 'Servicio de cable modem habilitado',
      catv_control_enabled: 'Control de CATV',
      clamp_mss_to_pmtu: 'Ajustar el MSS (tamaño máximo de segmento) al PMTU (MTU de la ruta)',
      default_prio_helpers: 'Netfilter helpers prioritarios (global)',
      default_prio_protos: 'Protocolos prioritarios (global)',
      default_tcp_prio_ports: 'Puertos TCP prioritarios (global)',
      default_udp_prio_ports: 'Puertos UDP prioritarios (global)',
      dns_enabled: 'DNS Habilitado',
      dns_first_server: 'Primer server DNS',
      dns_second_server: 'Segundo server DNS',
      dns_server_one: 'Primer servidor DNS',
      dns_server_three: 'Tercer servidor DNS',
      dns_server_two: 'Segundo servidor DNS',
      equipment_model: 'Modelo',
      extra_vlans: 'Extra Vlans',
      filter_by_mac_address: 'Bloquear tráfico de clientes si su dirección MAC no coincide con la del contrato',
      firewall_enabled: 'Habilitar control de firewall desde Wispro (deshabilita iptables_pre)',
      firewall_open_tcp_ports: 'Puertos TCP abiertos',
      firewall_open_udp_ports: 'Puertos UDP abiertos',
      gc_thresh1: 'Entradas ARP (gc_thresh1)',
      gc_thresh2: 'Entradas ARP (gc_thresh2)',
      gc_thresh3: 'Entradas ARP (gc_thresh3)',
      host: 'Host',
      in_safe_mode: 'Modo seguro',
      interface_graphs_enabled: 'Habilitar gráficos de interfaces',
      ip_accountig_enabled: 'Habilitar gráficos de contratos',
      iptables_tree_optimization_enabled: 'Optimizar reglas de iptables (usar sólo en versión de 64 bits)',
      lan_interface_ids: 'Interfaces LAN',
      language: 'Idioma',
      last_changes_applied_at: 'Cambios aplicados el',
      last_seen_online_at: 'Ultima vez visto online',
      low_latency_for_dns: 'DNS',
      low_latency_for_icmp: 'ICMP',
      low_latency_for_rdp: 'RDP',
      low_latency_for_sip: 'SIP',
      low_latency_for_ssh: 'SSH',
      low_latency_for_tcp_length: 'Tamaño paquetes TCP',
      low_latency_for_udp_length: 'Tamaño paquetes UDP',
      mail_relay_mail: 'Nombre de usuario',
      mail_relay_manipulated_for_sequreisp: 'Manejar la configuración de envíos de e-mail con wispro',
      mikrotik_service_branch: 'Rama de servicio',
      mikrotik_service_branch_stable: 'Estable',
      mikrotik_service_branch_beta: 'Beta',
      mikrotik_use_ssl: 'API-SSL',
      mikrotik_www_port: 'Puerto servicio www',
      mtu: 'MTU (unidad de transferencia máxima)',
      navigation_vlan: 'Vlan',
      nf_conntrack_max: 'Máximo nº de conexiones (nf_conntrack_max)',
      not_supported: 'Función no soportada por tu versión',
      notification_https_block: 'Bloqueo y redirección de tráfico HTTPS en clientes con notificaciones',
      ntp_enabled: 'NTP Habilitado',
      ntp_server_one: 'Primer servidor NTP',
      ntp_server_two: 'Segundo servidor NTP',
      olt_wan_provisioning: 'Aprovisionar WAN',
      pass: 'Contraseña',
      porn_filter_enabled: 'Filtro de pornografía infantil',
      port: 'Puerto API',
      profile: 'Perfil',
      quantum_factor: 'Ancho de banda que representa 1 cuanto',
      service_profile: 'Perfil Servicio',
      release_level: 'Release level',
      release_level_stable: 'Estable',
      release_level_beta: 'Beta',
      release_level_alpha: 'Alpha',
      rx_critical_power_lower: 'RX power critical lower',
      rx_critical_power_upper: 'RX power critical upper',
      rx_warning_power_lower: 'RX power warning lower',
      rx_warning_power_upper: 'RX power warning upper',
      ssh_port: 'Puerto SSH',
      state_free: 'Libre',
      state_from_scratch: 'Desde cero',
      state_linked: 'Vinculado',
      state_upgraded: 'Actualizado',
      tc_contracts_per_provider_in_lan: 'Árbol total de contratos individual por cada proveedor (LAN)',
      tc_contracts_per_provider_in_wan: 'Árbol total de contratos individual por cada proveedor (WAN)',
      tcp_length: 'Tamaño paquetes en bytes (TCP)',
      telnet_port: 'Puerto Telnet',
      tr069_profile: 'Perfil TR069',
      traffic_capture_enabled: 'Captura de tráfico habilitado',
      traffic_control: 'Control de ancho de banda',
      traffic_control_enabled: 'Control de ancho de banda habilitado',
      traffic_prio: 'Tráfico prioritario de baja latencia',
      udp_length: 'Tamaño paquetes en bytes (UDP)',
      uniq_contracts_mac_address: 'Dirección MAC de contratos única',
      url_notification_redirect: 'URL a redirigir despues de la notificación',
      use_global_prios: 'Deshabilitar prioridades por contrato y usar prioridades globales (experimental)',
      use_global_prios_strategy: 'Reglas de control de ancho de banda garantizado',
      wan_interface_ids: 'Interfaces WAN',
      web_proxy_enabled: 'Web proxy habilitado?',
      web_proxy_port: 'Puerto de web proxy',
      www_ssl_enabled: 'Usar www-ssl',
      zoneables_zone_ids: 'Zona'
    },
    service: { dhcp: 'DHCP', pppoe: 'PPPoE', static: 'Estática', subnet: 'Subred' },
    smtp_configuration: {
      address: 'Dirección del servidor',
      authentication: 'Tipo de autenticación',
      enable_starttls_auto: 'Start TLS auto',
      sender: 'Email (desde)',
      sender_password: 'Contraseña'
    },
    source: {
      create_new_source: 'Crear nuevo origen'
    },
    tag: {
      create_new_tag: 'Crear nueva etiqueta'
    },
    traffic: {
      data_count: 'Conteo de datos',
      data_total: 'Datos totales',
      data_total_extra: 'Datos extra totales',
      from_date: 'Desde',
      to_date: 'Hasta'
    },
    tv_services: {
      directv_go: {
        urns: 'URNs',
        paranoia_filter: 'Incluir eliminadas',
        paranoia_active: 'No',
        paranoia_deleted: 'Solo eliminadas',
        paranoia_both: 'Si',
        transaction_states: {
          conciliated: 'Conciliada',
          to_authorize: 'A Autorizar',
          to_conciliate: 'A Conciliar',
          to_invoice: 'A Facturar'
        },
        subscription_states: {
          active: 'Activa',
          inactive: 'Inactiva',
          to_inactive: 'Finaliza Pronto',
          suspended: 'Suspendida',
          unsync: 'Desincronizada'
        }
      }
    },
    user: {
      email: 'E-mail del usuario',
      last_login_at: 'Fecha del último inicio de sesión',
      last_login_at_never: 'Nunca',
      last_login_ip: 'Dirección IP del último inicio de sesión',
      last_login_ip_unknown: 'Desconocida',
      password_confirmation: 'Confirmación de contraseña',
      repeat_password: 'Ingrese contraseña nuevamente',
      role: 'Rol',
      role_ids: 'Roles',
      role_name: 'Permisos',
      unlock_token: 'Token de desbloqueo',
      userable_id: 'ID Utilizable'
    },
    vat_condition: {
      billing_regime: 'Regimen de Facturación',
      billing_regime_juridical: 'Regimen de Facturación (P. Jurídica)',
      billing_regime_person: 'Regimen de Facturación (P. Física)',
      common_regime: 'Regimen Común',
      common_regime_juridical: 'Regimen Común (P. Jurídica)',
      common_regime_person: 'Regimen Común (P. Física)',
      exempt: 'Exento',
      fantasy: 'Fantasia',
      final_consumer: 'Consumidor Final',
      juridic_person: 'Persona jurídica',
      natural_person: 'Persona natural',
      registered_vat_payer: 'Responsable Inscripto',
      self_employed_taxpayer: 'Responsable Monotributo',
      simplified_regime: 'Regimen Simplificado',
      general_regime: 'Régimen General de Ley Personas Morales',
      legal_entities_with_non_profit_purpose: 'Personas Morales con Fines no Lucrativos',
      wages_and_salaries_and_income_assimilated_to_salaries: 'Sueldos y Salarios e Ingresos Asimilados a Salarios',
      lease: 'Arrendamiento',
      property_disposal_or_acquisition_regime: 'Régimen de Enajenación o Adquisición de Bienes',
      other_income: 'Demás ingresos',
      residents_abroad_without_permanent_establishment_in_mexico:
        'Residentes en el Extranjero sin Establecimiento Permanente en México',
      dividend_income: 'Ingresos por Dividendos (socios y accionistas)',
      individuals_with_business_and_professional_activities:
        'Personas Físicas con Actividades Empresariales y Profesionales',
      interest_income: 'Ingresos por intereses',
      income_regime_for_obtaining_prizes: 'Régimen de los ingresos por obtención de premios',
      no_tax_obligations: 'Sin obligaciones fiscales',
      production_cooperative_societies_that_choose_to_defer_their_income:
        'Sociedades Cooperativas de Producción que optan por diferir sus ingresos',
      tax_incorporation: 'Incorporación Fiscal',
      agricultural_livestock_forestry_and_fishing_activities:
        'Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras',
      optional_for_groups_of_companies: 'Opcional para Grupos de Sociedades',
      coordinated: 'Coordinados',
      regime_of_business_activities_with_income_through_technological_platforms:
        'Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas',
      simplified_trust_regime: 'Régimen Simplificado de Confianza'
    },
    vpn_server: {
      ip_from: 'IP inicial',
      ip_to: 'IP final',
      local_ip: 'IP local'
    },
    zone: {
      zoneables: 'entidades'
    },
    zoneable: {
      zone_id: 'ID',
      zoneable_id: 'ID',
      zoneable_type: 'Tipo'
    }
  }
};
